function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  points: "80.11 247.67 0.67 247.67 163.56 136.52 188.84 173.52 80.11 247.67"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M108,212.44l-2-2.88c1.53-1.05,1.49-3.91-.12-6.26s-4.25-3.43-5.79-2.38-1.1,3,.31,6.64,3,8-1,10.7c-2.55,1.74-6.15,1.1-8.87-1.33L87.5,219l-3-4.32,3.1-2.11c-1.28-3.42-.57-7,2-8.75l2,2.88c-1.53,1-1.49,3.92.12,6.26s4.25,3.43,5.79,2.38,1.1-2.95-.31-6.63-3-8,1-10.71c2.55-1.74,6.15-1.09,8.87,1.33l3.1-2.11,3,4.32-3.1,2.11C111.24,207.11,110.53,210.7,108,212.44Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M167.87,171.57l-2-2.88c1.53-1,1.49-3.91-.12-6.26s-4.25-3.42-5.79-2.38-1.11,3,.31,6.64,3,8-1,10.71c-2.54,1.73-6.14,1.09-8.86-1.34l-3.1,2.12-2.95-4.32,3.09-2.12c-1.27-3.41-.56-7,2-8.74l2,2.88c-1.53,1-1.49,3.91.11,6.26s4.26,3.42,5.8,2.38,1.1-3-.31-6.64-3-8,.95-10.71c2.55-1.73,6.15-1.09,8.87,1.34l3.1-2.12,2.95,4.32-3.1,2.12C171.13,166.25,170.41,169.84,167.87,171.57Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M331.31.86h0a3,3,0,0,1,2.26.87A6.07,6.07,0,0,1,336,6.4l-1.3.44-1.13-.63L295.09,87c-1.5,3.15-5.15,5.89-8.16,6.13l-131,10.35-2.8,2.33a5,5,0,0,1-2.57-5.23s0-.07,0-.11a.28.28,0,0,1,0-.09h0a6.25,6.25,0,0,1,.61-2l38.51-80.81c1.5-3.15,5.16-5.89,8.17-6.13L330.87.87h.44m-.5-.86,0,.13-133,10.5c-3.3.26-7.16,3.14-8.78,6.56L150.48,98a7.64,7.64,0,0,0-.55,1.53h0l0,.23c0,.14,0,.28-.07.42v.2s0,.06,0,.1a5.74,5.74,0,0,0,3,6l.43.2.37-.31,2.61-2.17L287,93.83c3.29-.26,7.15-3.14,8.78-6.56l38.14-80,.43.24.29.16.31-.1,1.29-.44.52-.17V6.4a6.8,6.8,0,0,0-2.69-5.24,3.67,3.67,0,0,0-2.67-1L330.81,0Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M152.87,106.24a5.58,5.58,0,0,1-2.87-5.78l0-.26c0-.11,0-.23.05-.34v-.09h0a7.25,7.25,0,0,1,.57-1.68l38.52-80.81c1.57-3.3,5.43-6.18,8.61-6.43L330.83.34l.35,0,.05,0,.13,0a3.51,3.51,0,0,1,2.56,1,6.54,6.54,0,0,1,2.61,5.08v.39l-1.88.63L333.81,7,295.58,87.18c-1.57,3.3-5.44,6.18-8.61,6.43L156.11,104l-2.93,2.44-.31-.15ZM151,100.82a4.51,4.51,0,0,0,2,4.29l2.65-2.2h.17l131-10.36c2.84-.22,6.3-2.83,7.73-5.82L333.33,5.47l1.43.78.67-.22a5.34,5.34,0,0,0-2.16-3.85l-.1-.09a2.43,2.43,0,0,0-1.86-.69h-.39l-133,10.51c-2.83.22-6.3,2.83-7.72,5.82L151.64,98.55a6.11,6.11,0,0,0-.56,1.84Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M329.85,1.22l1-.08a3.17,3.17,0,0,1,.43,0h0a3,3,0,0,1,2.26.87A6.06,6.06,0,0,1,336,6.67l-1.29.43-1.13-.62,0,.08Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M204.52,188a12.34,12.34,0,0,1-4.8-3.95l-48.24-67.15a6.62,6.62,0,0,1-1.08-2.41h0l0-.3.53-.1-.54.07v0c-.06-.56-.46-5.4,3.69-7.59l.23-.12,3.27,1.45-.56,2.33L286.79,99.86c3.17-.25,7.44,2,9.51,5l47.75,66.47,2.36-1.08.18.58c1.66,5.39-2.65,7.23-2.69,7.25a4.59,4.59,0,0,1-1.63.41L209.23,189A9.61,9.61,0,0,1,204.52,188Zm-53.12-74,0,.1a5.21,5.21,0,0,0,.94,2.23l48.24,67.15c1.88,2.73,5.71,4.77,8.54,4.55l133-10.51a3.7,3.7,0,0,0,1.28-.32c.16-.07,3.17-1.39,2.27-5.36l-2,.94-48.27-67.2c-1.88-2.74-5.71-4.77-8.55-4.55L155.58,111.3l.7-2.9-2-.86C151.12,109.39,151.32,113.11,151.4,113.9Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M246.71,96.26l-90.81,7.17-2.8,2.33a5,5,0,0,1-2.57-5.23s0-.07,0-.11a.28.28,0,0,1,0-.09h0a6.25,6.25,0,0,1,.61-2l38.51-80.81a11.6,11.6,0,0,1,3.17-3.88Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M153.47,106.64a2.82,2.82,0,0,1-1.17-1c-.8-1.15-.75-2.86.12-4.69l38.52-80.81c1.57-3.3,5.43-6.18,8.61-6.44l133-10.51A3.58,3.58,0,0,1,336,4.54c.79,1.15.75,2.87-.13,4.7L297.33,90.05c-1.57,3.3-5.43,6.18-8.61,6.43L155.68,107A4.2,4.2,0,0,1,153.47,106.64ZM334.34,4.52a3.35,3.35,0,0,0-1.67-.25l-133,10.51c-2.83.23-6.3,2.84-7.72,5.83l-38.52,80.81c-.7,1.48-.78,2.8-.21,3.63a2.55,2.55,0,0,0,2.42.87l0,.54,0-.54,133-10.51c2.83-.22,6.29-2.83,7.72-5.82L334.87,8.78c.71-1.48.79-2.8.22-3.63A1.92,1.92,0,0,0,334.34,4.52Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M159.7,98.43a1.31,1.31,0,0,1-.54-.45,1.93,1.93,0,0,1,0-1.92l36.3-76.16a4.33,4.33,0,0,1,3.16-2.35L329.75,7.2a1.53,1.53,0,0,1,1.46.6,1.9,1.9,0,0,1,0,1.92l-36.3,76.16a4.29,4.29,0,0,1-3.16,2.34L160.62,98.58A1.71,1.71,0,0,1,159.7,98.43ZM330.21,8.31a.8.8,0,0,0-.37,0L198.73,18.62a3.25,3.25,0,0,0-2.28,1.74l-36.3,76.16c-.21.44-.19.73-.1.85s.34.15.48.14L291.65,87.15a3.22,3.22,0,0,0,2.27-1.73l36.3-76.16c.21-.44.19-.73.1-.86A.2.2,0,0,0,330.21,8.31Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M290.66,85.94a3.77,3.77,0,0,0,2.72-2l36.3-76.15h.12c1-.08,1.41.71.91,1.76l-36.3,76.16a3.78,3.78,0,0,1-2.72,2L160.58,98.05c-1,.08-1.42-.71-.92-1.76h0Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M154.4,107l2.62,1.16-.63,2.61,88.11-7-39.85,83.61a11.8,11.8,0,0,1-4.37-3.67L152,116.62C150.87,116,148.14,111.46,154.4,107Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M205.79,185.3a12.39,12.39,0,0,1-4.81-4l-47.4-68.92c-1.15-1.67-1.46-3.35-.86-4.61a3.56,3.56,0,0,1,3.14-1.86l133-10.51c3.18-.25,7.44,2,9.51,5l47.4,68.93c1.15,1.67,1.47,3.35.87,4.61a3.57,3.57,0,0,1-3.14,1.86l-133,10.51A9.57,9.57,0,0,1,205.79,185.3Zm87.35-87.86a8.51,8.51,0,0,0-4.16-.93L155.94,107a2.54,2.54,0,0,0-2.25,1.25c-.43.9-.15,2.2.78,3.54l47.4,68.93c1.87,2.72,5.7,4.76,8.54,4.54l133-10.51a2.54,2.54,0,0,0,2.26-1.25c.43-.91.14-2.2-.78-3.55l-47.4-68.92A11.25,11.25,0,0,0,293.14,97.44Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M188.23,154.67a4.44,4.44,0,0,1-1.74-1.44l-25.83-37.56a1.94,1.94,0,0,1-.32-1.9,1.53,1.53,0,0,1,1.34-.82L292.8,102.59a4.34,4.34,0,0,1,3.49,1.82L322.12,142a1.91,1.91,0,0,1,.32,1.9,1.52,1.52,0,0,1-1.34.82L190,155.06A3.62,3.62,0,0,1,188.23,154.67Zm105.85-50.73a2.52,2.52,0,0,0-1.2-.28L161.77,114c-.14,0-.38,0-.46.21s0,.43.23.83l25.84,37.57A3.25,3.25,0,0,0,189.9,154L321,143.63c.13,0,.38-.06.45-.21s0-.43-.23-.83L295.4,105A3.44,3.44,0,0,0,294.08,103.94Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M293,103.1a3.87,3.87,0,0,1,2.85,1.6l25.83,37.56c.66,1,.38,1.8-.62,1.88l-.33,0-25.81-37.53a3.85,3.85,0,0,0-2.85-1.6h-.16L161.14,115.38l0,0c-.66-1-.38-1.8.63-1.88l131.11-10.35H293m0-.25h-.18L161.72,113.22a1.26,1.26,0,0,0-1.11.65,1.64,1.64,0,0,0,.3,1.61l.08.12.17,0L291.94,105.3h.14a3.64,3.64,0,0,1,2.65,1.49l25.8,37.53.08.12h.15l.33,0a1.25,1.25,0,0,0,1.1-.66,1.64,1.64,0,0,0-.29-1.61l-25.84-37.57a4.08,4.08,0,0,0-3.05-1.7Z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M160.88,115.94l-.21-.29a1.94,1.94,0,0,1-.32-1.9,1.53,1.53,0,0,1,1.34-.82l131.12-10.36a4.34,4.34,0,0,1,3.49,1.82L322.14,142a1.91,1.91,0,0,1,.31,1.89,1.53,1.53,0,0,1-1.34.83l-.64,0-.17-.26-25.81-37.53a3.22,3.22,0,0,0-2.52-1.35Zm133.21-12a2.41,2.41,0,0,0-1.2-.28L161.78,114c-.14,0-.38,0-.46.21a.78.78,0,0,0,.1.61l130.46-10.31a4.31,4.31,0,0,1,3.49,1.83L321,143.61h0c.13,0,.38-.06.45-.22s0-.43-.23-.82L295.42,105A3.37,3.37,0,0,0,294.09,103.92Z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M285.27,101.34l3.22-.25c.64,0,.82-.6.4-1.21h0a2.46,2.46,0,0,0-1.94-1l-3.22.25c-.65.06-.83.6-.4,1.22h0A2.44,2.44,0,0,0,285.27,101.34Z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M164,111l.37,0c.66-.05.85-.6.41-1.23h0a2.44,2.44,0,0,0-2-1l-.37,0c-.66.06-.85.61-.41,1.24h0A2.46,2.46,0,0,0,164,111Z"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 167.72,
  y: 108.15,
  width: 19.55,
  height: 1.07,
  transform: "translate(-7.87 14.04) rotate(-4.43)"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 190.74,
  y: 106.79,
  width: 8.23,
  height: 1.07,
  transform: "translate(-7.89 15.78) rotate(-4.55)"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 270.65,
  y: 100.42,
  width: 9.43,
  height: 1.07,
  transform: "translate(-6.87 21.21) rotate(-4.36)"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  x: 201.31,
  y: 168.31,
  width: 1.07,
  height: 12.6,
  transform: "matrix(0.82, -0.57, 0.57, 0.82, -63.41, 145.12)"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 194.2,
  y: 160.59,
  width: 1.07,
  height: 7.35,
  transform: "translate(-58.8 139.28) rotate(-34.52)"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 206.45,
  y: 186.5,
  width: 2.94,
  height: 1.07,
  transform: "translate(-50.38 294.26) rotate(-64.52)"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  x: 213.04,
  y: 186.16,
  width: 2.94,
  height: 1.07,
  transform: "translate(-46.32 300.01) rotate(-64.52)"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 198.18,
  y: 11.14,
  width: 1.07,
  height: 3.36,
  transform: "translate(22.43 105.42) rotate(-31.4)"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  x: 214.69,
  y: 9.66,
  width: 1.07,
  height: 3.36,
  transform: "translate(25.62 113.81) rotate(-31.4)"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  x: 327.04,
  y: 1.03,
  width: 1.07,
  height: 3.36,
  transform: "translate(46.59 171.11) rotate(-31.41)"
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  x: 318.23,
  y: 1.6,
  width: 1.07,
  height: 3.36,
  transform: "translate(44.98 166.56) rotate(-31.4)"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M243.09,38c.53,0,.73.45.45,1a2.2,2.2,0,0,1-1.59,1.2l-26.56,2.1h-.08c-.53,0-.73-.45-.45-1a2.18,2.18,0,0,1,1.59-1.19L243,38h.08m0-.75H243l-26.56,2.1A3,3,0,0,0,214.18,41a1.55,1.55,0,0,0,0,1.51,1.29,1.29,0,0,0,1.13.59h.14L242,41a2.94,2.94,0,0,0,2.21-1.61,1.57,1.57,0,0,0,0-1.52,1.3,1.3,0,0,0-1.13-.59Z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M264.66,36.31c.53,0,.73.45.46,1a2.22,2.22,0,0,1-1.59,1.19l-1.92.15h-.08c-.52,0-.73-.45-.45-1a2.18,2.18,0,0,1,1.59-1.19l1.91-.16h.08m0-.75h-.14l-1.91.15a2.93,2.93,0,0,0-2.21,1.62,1.55,1.55,0,0,0,0,1.51,1.32,1.32,0,0,0,1.13.59h.14l1.91-.15a2.92,2.92,0,0,0,2.21-1.62,1.57,1.57,0,0,0,0-1.52,1.28,1.28,0,0,0-1.13-.58Z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M258.32,36.81c.53,0,.73.45.45,1A2.18,2.18,0,0,1,257.18,39l-10.56.84h-.08c-.53,0-.73-.44-.45-1a2.21,2.21,0,0,1,1.59-1.19l10.56-.84h.08m0-.75h-.14l-10.56.83a3,3,0,0,0-2.21,1.62,1.57,1.57,0,0,0,0,1.52,1.31,1.31,0,0,0,1.13.58h.14l10.56-.84a3,3,0,0,0,2.21-1.62,1.55,1.55,0,0,0,0-1.51,1.28,1.28,0,0,0-1.13-.59Z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M275.43,35.46c.52,0,.73.45.45,1a2.2,2.2,0,0,1-1.59,1.19l-5.86.46h-.07c-.53,0-.74-.45-.46-1a2.2,2.2,0,0,1,1.59-1.19l5.86-.47h.08m0-.75h-.14l-5.86.46a2.92,2.92,0,0,0-2.2,1.62,1.53,1.53,0,0,0,0,1.51,1.3,1.3,0,0,0,1.14.59h.13l5.86-.46a2.92,2.92,0,0,0,2.2-1.62,1.55,1.55,0,0,0,0-1.52,1.31,1.31,0,0,0-1.13-.58Z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M285.4,39.32c.53,0,.73.45.45,1a2.2,2.2,0,0,1-1.59,1.2L257.7,43.64h-.08c-.53,0-.73-.45-.45-1a2.18,2.18,0,0,1,1.59-1.19l26.56-2.1h.08m0-.75h-.14l-26.56,2.1a3,3,0,0,0-2.21,1.62,1.55,1.55,0,0,0,0,1.51,1.29,1.29,0,0,0,1.13.59h.14l26.56-2.1a2.94,2.94,0,0,0,2.21-1.61,1.57,1.57,0,0,0,0-1.52,1.3,1.3,0,0,0-1.13-.59Z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M239.18,43c.53,0,.73.44.45,1A2.2,2.2,0,0,1,238,45.2l-1.91.15h-.08c-.53,0-.73-.44-.45-1a2.21,2.21,0,0,1,1.59-1.19L239.1,43h.08m0-.75H239l-1.91.15A3,3,0,0,0,234.92,44a1.57,1.57,0,0,0,0,1.52,1.3,1.3,0,0,0,1.13.58h.14L238.1,46a3,3,0,0,0,2.21-1.62,1.57,1.57,0,0,0,0-1.52,1.3,1.3,0,0,0-1.13-.58Z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M254.17,41.79c.53,0,.73.45.45,1A2.18,2.18,0,0,1,253,44l-10.56.84h-.08c-.53,0-.73-.44-.45-1a2.21,2.21,0,0,1,1.59-1.19l10.56-.84h.08m0-.75H254l-10.56.83a3,3,0,0,0-2.21,1.62,1.57,1.57,0,0,0,0,1.52,1.31,1.31,0,0,0,1.13.58h.14l10.56-.84a3,3,0,0,0,2.21-1.62,1.55,1.55,0,0,0,0-1.51,1.28,1.28,0,0,0-1.13-.59Z"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M232.36,43.51c.52,0,.73.45.45,1a2.2,2.2,0,0,1-1.59,1.2l-5.85.46h-.08c-.53,0-.73-.44-.46-1A2.25,2.25,0,0,1,226.42,44l5.86-.46h.08m0-.75h-.14l-5.86.46a3,3,0,0,0-2.2,1.62,1.55,1.55,0,0,0,0,1.52,1.28,1.28,0,0,0,1.13.58h.14l5.85-.47a2.94,2.94,0,0,0,2.21-1.61,1.57,1.57,0,0,0,0-1.52,1.32,1.32,0,0,0-1.13-.59Z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M271,44.79c.53,0,.73.44.45,1A2.18,2.18,0,0,1,269.84,47l-26.56,2.1h-.08c-.53,0-.73-.44-.45-1a2.2,2.2,0,0,1,1.59-1.2l26.56-2.1H271m0-.75h-.14l-26.56,2.09a3,3,0,0,0-2.21,1.62,1.57,1.57,0,0,0,0,1.52,1.3,1.3,0,0,0,1.13.58h.14l26.56-2.1a3,3,0,0,0,2.21-1.62,1.57,1.57,0,0,0,0-1.52A1.31,1.31,0,0,0,271,44Z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M224.76,48.44c.53,0,.73.45.45,1a2.18,2.18,0,0,1-1.59,1.19l-1.91.15h-.08c-.53,0-.73-.45-.45-1a2.18,2.18,0,0,1,1.59-1.19l1.91-.16h.08m0-.75h-.14l-1.91.15a2.94,2.94,0,0,0-2.21,1.62,1.55,1.55,0,0,0,0,1.51,1.27,1.27,0,0,0,1.13.59h.14l1.91-.15a3,3,0,0,0,2.21-1.62,1.55,1.55,0,0,0,0-1.51,1.29,1.29,0,0,0-1.13-.59Z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M239.75,47.26c.53,0,.73.44.45,1a2.21,2.21,0,0,1-1.59,1.19l-10.56.83H228c-.53,0-.73-.45-.45-1a2.22,2.22,0,0,1,1.59-1.2l10.56-.83h.08m0-.75h-.14l-10.56.84A2.93,2.93,0,0,0,226.84,49a1.55,1.55,0,0,0,0,1.51,1.3,1.3,0,0,0,1.13.59h.14l10.56-.83a3,3,0,0,0,2.21-1.62,1.57,1.57,0,0,0,0-1.52,1.31,1.31,0,0,0-1.13-.58Z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M217.94,49c.52,0,.73.45.45,1a2.2,2.2,0,0,1-1.59,1.19l-5.85.47h-.08c-.53,0-.74-.45-.46-1A2.2,2.2,0,0,1,212,49.45l5.86-.47h.08m0-.75h-.14l-5.86.46a2.92,2.92,0,0,0-2.2,1.62,1.5,1.5,0,0,0,0,1.51,1.27,1.27,0,0,0,1.13.59H211l5.86-.46a3,3,0,0,0,2.21-1.62,1.57,1.57,0,0,0,0-1.52,1.31,1.31,0,0,0-1.13-.58Z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M240,54.1c.52,0,.73.44.45,1a2.18,2.18,0,0,1-1.59,1.19l-26.56,2.1h-.08c-.53,0-.73-.44-.45-1a2.21,2.21,0,0,1,1.59-1.19L240,54.1H240m0-.75h-.14l-26.56,2.09a3,3,0,0,0-2.21,1.62,1.57,1.57,0,0,0,0,1.52,1.28,1.28,0,0,0,1.13.58h.14L239,57.07a3,3,0,0,0,2.21-1.62,1.57,1.57,0,0,0,0-1.52,1.31,1.31,0,0,0-1.13-.58Z"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M234.92,69.93c.53,0,.73.44.45,1a2.18,2.18,0,0,1-1.59,1.19l-26.56,2.1h-.08c-.53,0-.73-.44-.45-1A2.21,2.21,0,0,1,208.28,72l26.56-2.1h.08m0-.75h-.14l-26.56,2.09A3,3,0,0,0,206,72.9a1.57,1.57,0,0,0,0,1.52,1.31,1.31,0,0,0,1.13.58h.14l26.56-2.1a3,3,0,0,0,2.21-1.62,1.57,1.57,0,0,0,0-1.52,1.3,1.3,0,0,0-1.13-.58Z"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M265.3,68.14c.53,0,.73.45.46,1a2.22,2.22,0,0,1-1.59,1.19l-26.57,2.1h-.07c-.53,0-.74-.45-.46-1a2.22,2.22,0,0,1,1.59-1.2l26.56-2.09h.08m0-.75h-.14L238.6,69.5a2.91,2.91,0,0,0-2.2,1.61,1.55,1.55,0,0,0,0,1.52,1.32,1.32,0,0,0,1.14.59h.13l26.57-2.1a2.9,2.9,0,0,0,2.2-1.62,1.53,1.53,0,0,0,0-1.51,1.29,1.29,0,0,0-1.13-.59Z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M261.6,52.4c.53,0,.73.44.45,1a2.2,2.2,0,0,1-1.59,1.2l-1.91.15h-.08c-.53,0-.73-.44-.45-1a2.21,2.21,0,0,1,1.59-1.19l1.91-.15h.08m0-.75h-.14l-1.91.15a3,3,0,0,0-2.21,1.62,1.57,1.57,0,0,0,0,1.52,1.28,1.28,0,0,0,1.13.58h.14l1.91-.15a3,3,0,0,0,2.21-1.62,1.57,1.57,0,0,0,0-1.52,1.3,1.3,0,0,0-1.13-.58Z"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M255.26,52.9c.52,0,.73.44.45,1a2.21,2.21,0,0,1-1.59,1.19L243.56,56h-.08c-.53,0-.73-.45-.45-1a2.2,2.2,0,0,1,1.59-1.2l10.56-.83h.08m0-.75h-.14L244.56,53a2.94,2.94,0,0,0-2.21,1.61,1.57,1.57,0,0,0,0,1.52,1.29,1.29,0,0,0,1.13.59h.14l10.56-.83a3,3,0,0,0,2.21-1.62,1.57,1.57,0,0,0,0-1.52,1.31,1.31,0,0,0-1.13-.58Z"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M272.36,51.55c.53,0,.73.44.45,1a2.2,2.2,0,0,1-1.59,1.2l-5.85.46h-.08c-.53,0-.73-.44-.45-1A2.21,2.21,0,0,1,266.43,52l5.85-.46h.08m0-.75h-.14l-5.85.46a3,3,0,0,0-2.21,1.62,1.57,1.57,0,0,0,0,1.52,1.31,1.31,0,0,0,1.13.58h.14l5.85-.46a3,3,0,0,0,2.21-1.62,1.57,1.57,0,0,0,0-1.52,1.28,1.28,0,0,0-1.13-.58Z"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M282.34,55.41c.52,0,.73.44.45,1a2.2,2.2,0,0,1-1.59,1.19l-26.56,2.1h-.08c-.53,0-.73-.44-.45-1a2.21,2.21,0,0,1,1.58-1.19l26.57-2.1h.08m0-.75h-.14l-26.56,2.09a3,3,0,0,0-2.21,1.62,1.57,1.57,0,0,0,0,1.52,1.28,1.28,0,0,0,1.13.58h.14l26.56-2.1a3,3,0,0,0,2.21-1.62,1.57,1.57,0,0,0,0-1.52,1.31,1.31,0,0,0-1.13-.58Z"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M236.12,59.06c.52,0,.73.45.45,1A2.2,2.2,0,0,1,235,61.28l-1.92.15H233c-.53,0-.74-.45-.46-1a2.2,2.2,0,0,1,1.59-1.19l1.92-.16h.08m0-.75H236l-1.92.15a2.9,2.9,0,0,0-2.2,1.62,1.5,1.5,0,0,0,0,1.51,1.29,1.29,0,0,0,1.13.59h.13L235,62a3,3,0,0,0,2.21-1.62,1.57,1.57,0,0,0,0-1.52,1.31,1.31,0,0,0-1.13-.58Z"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M272.63,67.74c.52,0,.73.45.45,1A2.18,2.18,0,0,1,271.49,70l-1.91.16h-.08c-.53,0-.74-.45-.46-1a2.22,2.22,0,0,1,1.59-1.19l1.92-.15h.08m0-.75h-.14l-1.92.15a2.92,2.92,0,0,0-2.2,1.62,1.5,1.5,0,0,0,0,1.51,1.27,1.27,0,0,0,1.13.59h.13l1.92-.15a3,3,0,0,0,2.21-1.62,1.55,1.55,0,0,0,0-1.51,1.29,1.29,0,0,0-1.13-.59Z"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M251.11,57.88c.52,0,.73.44.45,1A2.23,2.23,0,0,1,250,60.1l-10.56.83h-.08c-.53,0-.73-.45-.46-1a2.23,2.23,0,0,1,1.59-1.2L251,57.88h.08m0-.75H251L240.41,58a2.92,2.92,0,0,0-2.21,1.62,1.55,1.55,0,0,0,0,1.51,1.29,1.29,0,0,0,1.13.59h.14L250,60.85a3,3,0,0,0,2.21-1.62,1.57,1.57,0,0,0,0-1.52,1.31,1.31,0,0,0-1.13-.58Z"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M229.29,59.6c.53,0,.73.44.46,1a2.22,2.22,0,0,1-1.59,1.19l-5.86.46h-.08c-.52,0-.73-.45-.45-1a2.18,2.18,0,0,1,1.59-1.19l5.85-.47h.08m0-.75h-.14l-5.85.46a3,3,0,0,0-2.21,1.62,1.55,1.55,0,0,0,0,1.51,1.32,1.32,0,0,0,1.13.59h.14l5.86-.46a2.92,2.92,0,0,0,2.2-1.62,1.55,1.55,0,0,0,0-1.52,1.28,1.28,0,0,0-1.13-.58Z"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M267.91,61.88c.53,0,.74.44.46,1a2.22,2.22,0,0,1-1.59,1.2l-26.56,2.1h-.08c-.53,0-.73-.45-.46-1A2.22,2.22,0,0,1,241.27,64l26.57-2.1h.07m0-.75h-.13l-26.57,2.1a2.92,2.92,0,0,0-2.2,1.62,1.55,1.55,0,0,0,0,1.52,1.28,1.28,0,0,0,1.13.58h.14l26.56-2.09a3,3,0,0,0,2.2-1.62,1.52,1.52,0,0,0,0-1.52,1.28,1.28,0,0,0-1.13-.58Z"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M221.69,64.53c.53,0,.74.44.46,1a2.23,2.23,0,0,1-1.59,1.19l-1.92.15h-.08c-.52,0-.73-.44-.45-1a2.23,2.23,0,0,1,1.59-1.19l1.92-.15h.07m0-.75h-.13l-1.92.15a3,3,0,0,0-2.21,1.62,1.57,1.57,0,0,0,0,1.52,1.31,1.31,0,0,0,1.13.58h.14l1.92-.15a3,3,0,0,0,2.2-1.62,1.52,1.52,0,0,0,0-1.52,1.28,1.28,0,0,0-1.13-.58Z"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M236.68,64.34c.53,0,.74.45.46,1a2.2,2.2,0,0,1-1.59,1.19L225,67.4h-.08c-.53,0-.73-.44-.46-1A2.25,2.25,0,0,1,226,65.18l10.57-.83h.07m0-.75h-.13L226,64.43a3,3,0,0,0-2.2,1.62,1.52,1.52,0,0,0,0,1.52,1.28,1.28,0,0,0,1.13.58h.14l10.56-.84a2.9,2.9,0,0,0,2.2-1.62,1.53,1.53,0,0,0,0-1.51,1.32,1.32,0,0,0-1.14-.59Z"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M214.87,65.07c.53,0,.73.44.45,1a2.2,2.2,0,0,1-1.59,1.2l-5.85.46h-.08c-.53,0-.73-.44-.45-1a2.21,2.21,0,0,1,1.59-1.19l5.85-.46h.08m0-.75h-.14l-5.85.46a3,3,0,0,0-2.21,1.62,1.57,1.57,0,0,0,0,1.52,1.31,1.31,0,0,0,1.13.58h.14l5.85-.46A3,3,0,0,0,216,66.42a1.57,1.57,0,0,0,0-1.52,1.28,1.28,0,0,0-1.13-.58Z"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M353.6,248.06h0L321.24,218.5l5.49-4.41,28.78,34Zm-30.8-29.44,26.4,29.44h6.31l-28.89-32.5Z"
});

var _ref59 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M275.88,158.61l5.43,3.13a7.82,7.82,0,0,1,3.15,3.39l2.17,3.48,15,16.45L299.32,187l-21.77-18-6.49-10.46Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M299.32,187.69l-22.23-18.4-7-11.3,5.94.08,5.55,3.2A8.38,8.38,0,0,1,285,164.9l2.11,3.39,15.37,16.82Zm-21.36-19,21.36,17.65,1.56-1.29L286.17,168.9,284,165.42a7.3,7.3,0,0,0-3-3.22l-5.31-3.06-3.69,0Z"
}));

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M239.64,184.52l-3.5-4.35A8.71,8.71,0,0,1,234.3,176l-.77-5.07,7.4-.2,5.19,4.75ZM234.77,172l.59,3.87A7.68,7.68,0,0,0,237,179.5l2.62,3.25,5.1-7.12-4.17-3.81Z"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M342.15,248.06h0l-22.53-28.29,7.3-4.15,28.59,32.44Zm-20.91-28,22.29,28h10.59L326.69,217Z"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M255.48,248.06h-.39s-3.3-32.68-3.35-32.84l-.11-.39,8-5.12,6,4.72.05.12,15.84,33.51h-26Zm25.38,0L264.7,215.12,259.54,211l-6.66,4.27c.88,3.13,2.85,32.76,2.85,32.76h25.13Z"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M288.53,248.06c-10.61-23.49-10.32-22.49-10.32-22.49s-2.58,1.29-6,3.08l-.25,3-5.65-2.13L268.6,235c2.53,6.17,4.46,13,4.46,13Z"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M253.36,218.64a2.93,2.93,0,0,1-1.34-1.29l-6.7-12.52a2.88,2.88,0,0,1-.3-.82l-3.64-18h0v-.19l-.16-.83.2,0h0l.83-.17,0,.21,8.09.34a3.07,3.07,0,0,1,1.11.27l8.82,4a2.9,2.9,0,0,1,.69.44c2.6,2.2,11.15,9.52,12.12,11.15,1.1,1.85,2.42,13.91,1.54,16.35-.63,1.72-4.05,3.61-6.82,4.89a3,3,0,0,1-2.72-.11l-6.91-3.86a1.94,1.94,0,0,0-1.95.05,3,3,0,0,1-2.36.34A3.24,3.24,0,0,1,253.36,218.64ZM242.49,186l3.58,17.76a2,2,0,0,0,.19.53L253,216.85a1.92,1.92,0,0,0,1.19,1,1.87,1.87,0,0,0,1.51-.23,3,3,0,0,1,3-.06l6.91,3.86a2,2,0,0,0,1.75.06c3.54-1.64,5.88-3.24,6.26-4.27.78-2.17-.5-13.84-1.45-15.44-.66-1.11-6.45-6.26-11.9-10.88a1.83,1.83,0,0,0-.44-.28l-8.81-4a2,2,0,0,0-.72-.17Z"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M210.47,129.11a1.67,1.67,0,0,1-1-1.11c-.29-1.24.88-2.7,1-2.86l3.16-2.88,8.09-3,9.56-.87,6.13,3.89,11.54,6.3,4.4,4v.25c-.16,3.61-.28,3.65-.65,3.79-.14.05-6.2,1.63-11.26,2.94l-.23.06-14.39-9.07.66-.46a1.62,1.62,0,0,0,.72-1.29,1.65,1.65,0,0,0-.59-1.36l-1.3-1.11h-3.6l-6.66.25L213,128.82a2.56,2.56,0,0,1-2.49.33Zm3.69-5.88-2.85,2.64a3,3,0,0,0-.75,1.88c0,.11.1.28.42.42a1.51,1.51,0,0,0,1.43-.22l3.32-2.41,7-.26h4l1.61,1.36a2.78,2.78,0,0,1,.36,3.83l12.72,8,10.68-2.79c.07-.49.14-1.62.19-2.65l-4-3.64-11.41-6.21-5.85-3.71-9.12.83Z"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M249.81,133.47l-.12-.09-9.41-8.33.05-.55.24-.14,2.65-1.37,1.86-.17,2.53,1,6.62,7.16.33.86a1.51,1.51,0,0,1-1.56,2Zm-8.05-8.54,8.52,7.54,2.83.3a.42.42,0,0,0,.38-.16.44.44,0,0,0,.07-.42l-.29-.77L247,124.7l-2.06-.79-1.52.14Z"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M264,144.47a1.62,1.62,0,0,1-.49-.38l-1.85-2.21a1.44,1.44,0,0,1-.22-1.54l3.06-6.92a1.45,1.45,0,0,1,1.9-.77l1.06.44a1.49,1.49,0,0,1,.91,1.26h0l.2,2.92a.34.34,0,0,0,.23.33l3.52,1.61a.4.4,0,0,0,.49-.12l1.57-2.16a1.45,1.45,0,0,1,1.53-.57,1.5,1.5,0,0,1,1.19,1.65L276,145.83a1.45,1.45,0,0,1-1.73,1.24,1.49,1.49,0,0,1-1.05-.8l-1.14-2.38a.37.37,0,0,0-.23-.21l-4.36-1.41a.4.4,0,0,0-.43.14l-1.29,1.64a1.44,1.44,0,0,1-1.13.56A1.35,1.35,0,0,1,264,144.47ZM267,134.09h0l-1.06-.44a.39.39,0,0,0-.51.21l-3.06,6.93a.38.38,0,0,0,.06.41l1.85,2.21a.38.38,0,0,0,.31.14.39.39,0,0,0,.31-.15l1.28-1.65a1.48,1.48,0,0,1,1.61-.49l4.36,1.41a1.49,1.49,0,0,1,.87.76l1.14,2.38a.39.39,0,0,0,.28.22.38.38,0,0,0,.31-.07.44.44,0,0,0,.16-.26l1.08-7.82a.4.4,0,0,0-.3-.44l-.08,0a.4.4,0,0,0-.42.15l-1.57,2.16a1.48,1.48,0,0,1-1.8.47l-3.51-1.61a1.51,1.51,0,0,1-.86-1.23l-.2-2.93A.4.4,0,0,0,267,134.09Z"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M271.21,136.1a6.51,6.51,0,0,1-2.37-1.73,3.31,3.31,0,0,1-.36-2.76l1.4-4.39a3.84,3.84,0,0,1,4-2.68,4,4,0,0,1,3.61,4.46l-.48,3.49-.41,1.2c-.42,1.22-2,3-3.5,3h0A5,5,0,0,1,271.21,136.1Zm3.58-10.22a3,3,0,0,0-1-.27,2.77,2.77,0,0,0-2.87,1.94l-1.39,4.39a2.2,2.2,0,0,0,.24,1.85,6.84,6.84,0,0,0,3.33,1.8h0c.87,0,2.13-1.26,2.47-2.25l.4-1.15.44-3.33a2.84,2.84,0,0,0-.61-2.19A2.91,2.91,0,0,0,274.79,125.88Z"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M273.5,155.8l-9-6.68.8-4.36.66-.72a4.15,4.15,0,0,1,6.93,1.36l1.08,2.85Zm-7.85-7.14,6.9,5.1.31-5.35-1-2.63a3.08,3.08,0,0,0-5.14-1l-.45.49Z"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M257.88,206.06l-1.18-.8a48.11,48.11,0,0,1-17.58-21.42,2.66,2.66,0,0,1-.2-1v-8.52l.07-.12,4.86-8.45,8.65,5c1.86,1.35,10.93,8,11.54,8.89s6.36,12.81,7,14.16l.18.36ZM240,174.61v8.22a1.45,1.45,0,0,0,.12.59,47,47,0,0,0,17.19,21l.49.33,12.12-10.82c-2.56-5.29-6.35-13-6.76-13.66s-7.14-5.62-11.23-8.59l-7.68-4.41Z"
});

var _ref71 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M321.72,210.51l1-.95.22.16,2.33-4s0,0,0,0l-4.2-.68-.73.44-1.62-1.87-1.9,1.92L304,193.82l-1.29-6.3-6.13-.9-24.34,12.73-13.66-.48-6.43-15.69.13,2.06a141.92,141.92,0,0,1,.09,16.24l-.12,2.37a2.19,2.19,0,0,0,1.93,3.07l2.69.1,7.4,11.06-.79.21-3.24.27h0l-1.89,3.28,5.31,17.63a5.65,5.65,0,0,0,6.21,4l7.81-1.1,1.89-3.28-1.88-2.15,7.67-.75,1.89-3.27h0l-3.45-1.37a6.84,6.84,0,0,0-6.1-3L279.42,217a73.7,73.7,0,0,0,23.41-13.36l15,9.26,2.57,3.54,4.74,6.23a2.83,2.83,0,0,0,4.71-.31h0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M266.41,243.43a6.17,6.17,0,0,1-3.25-3.81l-5.38-17.85,2.14-3.64.18-.1,3.32-.28-6.82-10.21-2.42-.09a2.72,2.72,0,0,1-2.44-3.72l.11-2.28a143,143,0,0,0-.08-16.17l-.34-5.33,7.53,18.4,13.18.46,24.36-12.75,6.68,1,1.33,6.5,12.31,11.2,1.94-2,1.71,2,.51-.31,4.66.75.26.47-.12.26-2.65,4.61-.34-.26-.36.33,8.05,11.72-.17.29a3.38,3.38,0,0,1-5.61.36L320,216.74l-2.51-3.47-14.56-9a75.34,75.34,0,0,1-23,13.1L278.32,228a7.21,7.21,0,0,1,5.83,3.06l3.5,1.39.2.43-.11.23-2,3.55-6.91.67,1.44,1.65L278,242.82,270,244A6.23,6.23,0,0,1,266.41,243.43ZM259,221.91l5.24,17.4a5.07,5.07,0,0,0,5.61,3.59l7.56-1.07,1.56-2.72-2.31-2.65,8.44-.82,1.44-2.5-3-1.2-.09-.13a6.35,6.35,0,0,0-5.66-2.75h-.63l1.87-12.5.32-.1a73.82,73.82,0,0,0,23.22-13.25l.3-.26,15.48,9.61,2.56,3.54,4.74,6.21a2.3,2.3,0,0,0,3.63,0L321,210.43l1.71-1.57.09.07,1.64-2.86-3.25-.52-.95.57-1.54-1.77-1.85,1.87L303.53,194.1,302.28,188l-5.59-.82-24.31,12.72-14.15-.49-5.32-13a143.7,143.7,0,0,1,0,15.11l-.17,2.56a1.64,1.64,0,0,0,.12,1.55,1.62,1.62,0,0,0,1.34.77l3,.11,8,11.91-1.6.42-3,.25Z"
}));

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M268.3,240.15a6.14,6.14,0,0,1-3.25-3.81l-5.44-18.05.4-.21,5.6-3.17-7.12-10.64-2.43-.1a2.73,2.73,0,0,1-2.44-3.71l.22-9.4,20.23,4.45,24.32-12.73,3.92.58a4,4,0,0,1,3.31,3.13l.78,3.77,12.31,11.2.21-.22a2.28,2.28,0,0,1,3.34.1L326,205.7l-1.73,1.61,6.53,9.5a4.27,4.27,0,0,1,.18,4.55l-.8,1.39a.74.74,0,0,1-.59.37.73.73,0,0,1-.64-.29l-7.14-9.37L319.34,210l-14.57-9a75.22,75.22,0,0,1-23,13.1l-1.58,10.62c7.14.36,7.58,8.05,7.59,8.13v.21l-.31.36h-.27l-8.22.8,1.22,5.29-8.39,1.19A6.21,6.21,0,0,1,268.3,240.15Zm-7.41-21.34L266.07,236a5.09,5.09,0,0,0,5.62,3.59l7.23-1-1.23-5.34,9-.87c-.23-1.74-1.39-6.66-7.08-6.61H279l1.87-12.5.32-.1a73.6,73.6,0,0,0,23.21-13.25l.3-.26,15.48,9.61,2.57,3.54,6.83,9,.55-1a3.21,3.21,0,0,0-.13-3.4l-7.06-10.27,1.66-1.52-3.11-3.58a1.21,1.21,0,0,0-.87-.42,1.19,1.19,0,0,0-.89.36l-.95.95-13.32-12.12-.85-4.12a2.89,2.89,0,0,0-2.42-2.28l-3.57-.53-24.36,12.75-19.33-4.25-.24,8.39a1.65,1.65,0,0,0,1.45,2.32l3,.11,8.07,12.07Z"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M252,202l.83,0-.1,1.87a2.84,2.84,0,0,0,.23,2.07,1.57,1.57,0,0,0,1.3.56l2.46.1,1.33-2.18.7.43-1.58,2.59-2.94-.11a3,3,0,0,1-1.16-.26,2,2,0,0,1-.77-.64,3.49,3.49,0,0,1-.38-2.68L252,202m-.47-.52,0,.5-.08,1.73a4,4,0,0,0,.47,3.06,2.57,2.57,0,0,0,1,.79,3.35,3.35,0,0,0,1.35.31l2.94.11h.29l.15-.25,1.59-2.59.26-.42-.42-.27-.71-.43-.42-.26-.27.43-1.18,1.93-2.16-.09c-.6,0-.81-.21-.92-.36a2.15,2.15,0,0,1-.15-1.64h0v-.09l.1-1.87,0-.5-.5,0-.82,0-.5,0Z"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M257.4,206.52l5.88,9.31-.7.44L256.71,207l.69-.44m.16-.69-.42.26-.7.44-.42.27.26.42,5.88,9.32.26.42.43-.27.7-.44L264,216l-.27-.42-5.87-9.31-.27-.42Z"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M255.18,192c-2.53-1.2-4.76-4.42-7.34-8.14-.63-.91-1.28-1.85-2-2.81-4.93-6.88-16-10.86-16.11-10.9l-.17-.06-5-7.91-.09-3.34a12.92,12.92,0,0,0-4.28-9.23,8.35,8.35,0,0,1-3.55-1.53L215,149l-4.6,6.52.18,3.72a2.27,2.27,0,0,1-1.06,2.91,2.31,2.31,0,0,1-2.71-.46l-.85.18,0-11.91,3.48-8.56,4.11-2.61,1.74-6.65,7.17-2.56,8.37.69,4.44,3.12-.1.37c-.13.45-1.26,4.52-2.22,5.78a10.71,10.71,0,0,1-1.47,1.42l23-8.07,1.95,6.56-2,1.09-13.82,13,4.92,4.59,10.41,7.78L262.64,184a6.09,6.09,0,0,1,.44,4.32,6,6,0,0,1-3.24,3.5A5,5,0,0,1,255.18,192ZM234,170.79c3.8,1.81,9.46,5.07,12.72,9.62q1,1.46,2,2.82c4.27,6.17,6.87,9.56,10.63,7.64a4.93,4.93,0,0,0,2.7-2.85,5,5,0,0,0-.37-3.53l0-.07L255,166.57l-10.19-7.63L239,153.53l14.82-13.92,1.33-.71-1.38-4.64-28,9.82,2.61-2a26.17,26.17,0,0,0,3.73-3.19,23.26,23.26,0,0,0,1.93-5.06l-3.58-2.51-7.85-.65-6.42,2.29-1.7,6.5-4.17,2.67L207,150.24v10.29l.24-.05.2.3a1.22,1.22,0,0,0,1.56.4,1.23,1.23,0,0,0,.56-1.57,1.16,1.16,0,0,1-.08-.32l-.2-4.11,5-7,2.52-1.36.27.21a7.52,7.52,0,0,0,3.39,1.52h.21l.15.14a14,14,0,0,1,4.79,10.14l.09,3,4.6,7.35C230.79,169.38,232.19,169.92,234,170.79Z"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M260,199.6a9,9,0,0,1-3.76-3.34,44,44,0,0,1-4.7-10.21l0-.17.61-14.53,5.88-6.69,20.62-1.29,7.64,5.56,14,16.28,0,.16a16.32,16.32,0,0,1-7.91,15.89l-.28.16a27.59,27.59,0,0,1-25.67,1.22l-6.42-3Zm-7.4-13.77a43.91,43.91,0,0,0,4.55,9.86,7.91,7.91,0,0,0,3.31,2.94l.05,0,6.42,3a26.5,26.5,0,0,0,24.62-1.14l.32-.19a15.25,15.25,0,0,0,7.41-14.68l-13.78-16-7.18-5.22-19.8,1.24-5.34,6.07Z"
});

var _ref77 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M278.51,167.25l.63-1.65-16.32-22.4-8.25-3.32s-10.28,1.86-15.88,5l-6,6.2-1.64.69-1.44,2.51.58,12.56,8.89,3.53,3.93-.76,17.28,9.15,17.08-8.58,1.44-2.51Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M229.69,167.19l-.61-13.07,1.61-2.79,1.71-.72,6-6.22c5.63-3.13,15.63-5,16.06-5l.15,0,8.54,3.44,16.57,22.76-.62,1.63.36.45-1.7,3-17.48,8.78-17.36-9.19-3.89.75Zm.48-12.8.56,12.06,8.42,3.34,4-.76,17.2,9.11,16.7-8.39,1.17-2-.28-.36.63-1.66-16-22.05-8-3.21c-1.28.25-10.39,2-15.5,4.86l-6,6.22-1.58.66Z"
}));

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M231.14,164.69l-.62-13.15,9.35-9.65c5.62-3.13,15.63-5,16-5l.15,0,8.54,3.43L281.19,163l-1.93,5-17.52,8.8-17.35-9.19-3.9.75Zm.48-12.73.56,12,8.42,3.34,4-.76,17.21,9.11,16.65-8.36,1.57-4.09-16.06-22.05-8-3.2c-1.28.24-10.39,2-15.5,4.86Z"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M210.21,127.22l-.35-.4,0-.29.63-2.52.17-.16,5.73-3.4a1.18,1.18,0,0,1,1-.09,1.17,1.17,0,0,1,.71.7l1.5,4.08a1.19,1.19,0,0,1-.13,1.07,1.15,1.15,0,0,1-.94.52l-5.1.18Zm1.25-2.56-.34,1.4,2.28-.22,5.13-.18a.1.1,0,0,0,.09,0,.07.07,0,0,0,0-.09l-1.5-4.09-.14-.05Z"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M220.06,126.36l-.09-.44-.53-5.09.07-.14,1.09-1.91,2.2-1.51H223l8.12.52a1.28,1.28,0,0,1,1.16,1,1.26,1.26,0,0,1-.6,1.39l-3.41,2L227,126.33l-.4,0Zm.49-5.32.43,4.24h5.18l1.2-3.77.21-.19,3.58-2.09a.2.2,0,0,0-.09-.38l-7.94-.5-1.69,1.16Z"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M238.86,136.12l-.21-.14-3.45-2-6-7.79.15-.31,1.3-3.44.16-.16.11,0,4.88-2a3.06,3.06,0,0,1,3.19.58l9.31,8.49a1.05,1.05,0,0,1-.47,1.8l-7,1.67-1.38,3.2ZM236,133.21l2.72,1.57L239.9,132l.18-.18.16,0,7.31-1.73-9.33-8.45a2,2,0,0,0-2.06-.37l-4.66,1.86L230.4,126Z"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M212.53,139.93l-.14-.08a.89.89,0,0,1-.35-.61l-.39-3.84a.87.87,0,0,1,.19-.64l3.7-4.51a.85.85,0,0,1,.61-.31.82.82,0,0,1,.65.24l.84.81a.84.84,0,0,1,.25.79l-1.4,7a.85.85,0,0,1-.68.68l-2.74.53A.84.84,0,0,1,212.53,139.93Zm.2-4.55.36,3.52,2.37-.46,1.36-6.76-.6-.57Z"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M217.81,139.07a.82.82,0,0,1-.32-.26.86.86,0,0,1-.14-.74l2.08-7.5a.91.91,0,0,1,.32-.47l1.65-1.2a.83.83,0,0,1,.53-.16l6.27.11a.88.88,0,0,1,.78.53.86.86,0,0,1-.18.93l-2.08,2.19-2.6,6.26a.85.85,0,0,1-.82.53l-5.14-.13A.82.82,0,0,1,217.81,139.07Zm2.64-8.14-2,7.16,4.73.13,2.58-6.2a.78.78,0,0,1,.17-.26l1.76-1.84-5.72-.11Z"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M232.55,142.81l-.1-.06-6-3.88a.88.88,0,0,1-.31-1.09l2.34-5.1a.88.88,0,0,1,.41-.42l3.59-1.72a.87.87,0,0,1,.77,0l9.09,4.77a.88.88,0,0,1,.46.66l.23,1.95a.85.85,0,0,1-.59.93l-7.06,2.24-1.94,1.59A.86.86,0,0,1,232.55,142.81Zm-5.34-4.75,5.7,3.71,1.88-1.53a.76.76,0,0,1,.28-.15l6.9-2.19-.21-1.67-8.9-4.67-3.42,1.64Z"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M206.3,163.18a1.4,1.4,0,0,1-.6-.53l-1.49-2.39a1.44,1.44,0,0,1-.22-.7l-.33-8.95a1.46,1.46,0,0,1,.34-1l.39-.47a2.77,2.77,0,0,1,3.6-.53l2.89,1.86a2.47,2.47,0,0,1,.8,3.32l-3,5.26a.31.31,0,0,0,0,.21l.28,2.49a1.42,1.42,0,0,1-1.5,1.57l-.57,0A1.34,1.34,0,0,1,206.3,163.18Zm.92-13.75a1.7,1.7,0,0,0-2,.44l-.39.47a.29.29,0,0,0-.08.23h0l.33,9a.35.35,0,0,0,.05.18l1.49,2.38a.35.35,0,0,0,.27.17l.58,0a.31.31,0,0,0,.27-.11.32.32,0,0,0,.09-.27l-.27-2.49a1.39,1.39,0,0,1,.18-.87l3-5.25a1.4,1.4,0,0,0-.46-1.89l-2.89-1.86Z"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M212.33,149.54a1.76,1.76,0,0,1-.56-.42l-3.27-3.72a1.73,1.73,0,0,1-.34-1.71l1-3a1.71,1.71,0,0,1,.62-.83l4.32-3.13a1.71,1.71,0,0,1,1.24-.31l1.91.25a1.71,1.71,0,0,1,1.49,1.56l.51,5.53a1.84,1.84,0,0,1-.08.7l-.77,2.32a1.68,1.68,0,0,1-.92,1l-3.72,1.7A1.7,1.7,0,0,1,212.33,149.54Zm5-11.71-.2-.05-1.91-.26a.67.67,0,0,0-.47.12l-4.32,3.13a.64.64,0,0,0-.23.31l-1,3a.7.7,0,0,0,.13.65l3.28,3.72a.64.64,0,0,0,.76.16l3.72-1.69a.64.64,0,0,0,.35-.39l.77-2.33a.57.57,0,0,0,0-.26l-.51-5.53A.66.66,0,0,0,217.34,137.83Z"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M221.55,149.05a2.31,2.31,0,0,1-1-.83l-.59-.88a2.37,2.37,0,0,1-.35-1.68l1.09-6.66a2.35,2.35,0,0,1,.48-1.08l1.19-1.51a2.36,2.36,0,0,1,2-.9l2.71.14a2.46,2.46,0,0,1,1.06.31l4.29,2.47a2.31,2.31,0,0,1,1,1.09l1,2.27a2.35,2.35,0,0,1-.55,2.66l-6.16,5.75a2.35,2.35,0,0,1-2.55.43l-3.55-1.55Zm6-12.21a1.31,1.31,0,0,0-.48-.12l-2.72-.14a1.28,1.28,0,0,0-1.07.49l-1.19,1.52a1.39,1.39,0,0,0-.26.58l-1.1,6.66a1.3,1.3,0,0,0,.2.92l.58.88a1.4,1.4,0,0,0,.56.47l3.55,1.55a1.29,1.29,0,0,0,1.39-.24l6.15-5.74a1.28,1.28,0,0,0,.3-1.45l-1-2.26a1.29,1.29,0,0,0-.53-.6l-4.3-2.47Z"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M248,132.65l.18.81-5.31,1.23-.18-.81,5.31-1.23m.19-.3-.25.06-5.31,1.23-.24.05,0,.25.19.8.05.25.25-.06,5.31-1.23.24-.06-.05-.24-.19-.8-.05-.25Z"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M240.24,140.34l.22.79-4.24,1.15-.22-.8,4.24-1.14m.17-.31-.24.06-4.23,1.15-.24.07.06.24.22.8.07.24.24-.07,4.23-1.15.24-.06-.06-.24-.22-.8-.07-.24Z"
});

var _ref90 = /*#__PURE__*/React.createElement("rect", {
  x: 290.91,
  y: 172.07,
  width: 1.07,
  height: 23.19,
  transform: "translate(-49.28 234.48) rotate(-40.7)"
});

var _ref91 = /*#__PURE__*/React.createElement("rect", {
  x: 270.98,
  y: 185.16,
  width: 1.07,
  height: 20.61,
  transform: "translate(-59.28 145.46) rotate(-27.15)"
});

var _ref92 = /*#__PURE__*/React.createElement("rect", {
  x: 253.45,
  y: 148.69,
  width: 1.07,
  height: 30.22,
  transform: "translate(-44.63 210.41) rotate(-41.69)"
});

var _ref93 = /*#__PURE__*/React.createElement("rect", {
  x: 268.85,
  y: 141.57,
  width: 1.07,
  height: 29.5,
  transform: "translate(-37.63 208.69) rotate(-39.81)"
});

var _ref94 = /*#__PURE__*/React.createElement("rect", {
  x: 213.34,
  y: 143.43,
  width: 5.55,
  height: 1.07,
  transform: "translate(-39.9 100.48) rotate(-24.03)"
});

var _ref95 = /*#__PURE__*/React.createElement("rect", {
  x: 226.63,
  y: 142.97,
  width: 1.07,
  height: 6.08,
  transform: "translate(-12.71 270.04) rotate(-60.07)"
});

var _ref96 = /*#__PURE__*/React.createElement("rect", {
  x: 234.53,
  y: 133.17,
  width: 1.07,
  height: 8.19,
  transform: "translate(-10.91 253.86) rotate(-55.64)"
});

var _ref97 = /*#__PURE__*/React.createElement("rect", {
  x: 236.48,
  y: 123.49,
  width: 1.07,
  height: 10.1,
  transform: "translate(-25.75 188.96) rotate(-41.42)"
});

var _ref98 = /*#__PURE__*/React.createElement("rect", {
  x: 223.41,
  y: 121.27,
  width: 4.43,
  height: 1.07,
  transform: "translate(-0.9 1.68) rotate(-0.43)"
});

var _ref99 = /*#__PURE__*/React.createElement("rect", {
  x: 206.9,
  y: 151.67,
  width: 4.14,
  height: 1.07,
  transform: "translate(-27.18 257.41) rotate(-60.08)"
});

var _ref100 = /*#__PURE__*/React.createElement("rect", {
  x: 221.72,
  y: 131.73,
  width: 4.61,
  height: 1.07,
  transform: "translate(-7.51 13.64) rotate(-3.43)"
});

var _ref101 = /*#__PURE__*/React.createElement("polygon", {
  points: "334.2 248.06 317.63 224.33 318.51 223.72 335.51 248.06 334.2 248.06"
});

var _ref102 = /*#__PURE__*/React.createElement("polygon", {
  points: "297.19 248.06 291.95 237.88 292.9 237.39 298.39 248.06 297.19 248.06"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M243.11,181.12a1.61,1.61,0,0,1,.79.21,1.57,1.57,0,0,1-.79,2.93,1.6,1.6,0,0,1-.78-.21,1.57,1.57,0,0,1,.78-2.93m0-.5h0a2.07,2.07,0,1,0,1.8,3.1,2.09,2.09,0,0,0,.2-1.57,2,2,0,0,0-1-1.25,2,2,0,0,0-1-.28Z"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M242.21,184.59l-.15-.07a2.11,2.11,0,0,1,.5-3.86,2.1,2.1,0,0,1,2.38,3.08h0A2.11,2.11,0,0,1,242.21,184.59Zm1.35-2.83a1.06,1.06,0,0,0-.72-.07,1,1,0,0,0-.73,1.27,1,1,0,0,0,.49.62,1,1,0,0,0,1.41-.37h0a1.05,1.05,0,0,0-.38-1.42Z"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M259.54,245.11a2.11,2.11,0,1,1,2.91-1.23h0a2.11,2.11,0,0,1-2.67,1.32Zm1.36-2.84-.12,0a1,1,0,0,0-1.31.64,1,1,0,0,0,.65,1.31,1,1,0,0,0,1.31-.64A1,1,0,0,0,260.9,242.27Z"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M229,129l3.17.79-.2.8-3.17-.79.2-.8m-.18-.3-.07.24-.2.8-.06.24.24.06,3.17.8.25.06.06-.25.2-.8.06-.24-.24-.06-3.17-.79-.24-.06Z"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M256.16,134.91l.21.8-4.23,1.14-.22-.79,4.24-1.15m.17-.31-.24.07-4.23,1.14-.24.07.06.24.22.8.06.24.24-.07,4.24-1.14.24-.07-.07-.24-.21-.8-.07-.24Z"
});

var _ref108 = /*#__PURE__*/React.createElement("rect", {
  x: 273.82,
  y: 130.37,
  width: 1.07,
  height: 4.07,
  transform: "translate(13.24 289.31) rotate(-56.76)"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M243.34,119.57c.54,0,5.07.09,7.55,3.09l2.49,3-.64.53-2.49-3c-2.25-2.72-6.6-2.78-6.92-2.78h0v-.83h0m0-.25H243v1.33h.26c.19,0,4.53,0,6.74,2.69l2.49,3,.16.19.19-.16.63-.52.2-.16-.16-.19-2.49-3c-2.55-3.09-7.21-3.18-7.74-3.18Z"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M254.44,127.11l2.16,3.14-.68.47-2.16-3.14.68-.47m.06-.35-.2.14-.68.47-.21.14.14.21,2.16,3.14.14.21.21-.14.68-.47.21-.14-.15-.21L254.64,127l-.14-.21Z"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M207,129.29a6.59,6.59,0,0,0,1,2.15l-.68.47a7.26,7.26,0,0,1-1.1-2.43l.8-.19m.19-.3-.24.06-.81.19-.24.06.06.24a7.39,7.39,0,0,0,1.14,2.52l.14.2.21-.14.68-.47.2-.14-.14-.21a5.91,5.91,0,0,1-.94-2.07l-.06-.24Z"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M207.59,123.48l.64.53a6.86,6.86,0,0,0-1.38,4.35l-.82,0a7.61,7.61,0,0,1,1.56-4.93m0-.35-.16.19a7.87,7.87,0,0,0-1.62,5.11l0,.25.25,0,.82,0,.25,0,0-.25a6.63,6.63,0,0,1,1.32-4.17l.16-.19-.19-.16-.64-.53-.19-.16Z"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M273.24,121.67l0,.82c-2.89.08-4.21,3-4.22,3l-.76-.34c.06-.14,1.54-3.38,5-3.47m.25-.26h-.25c-3.58.1-5.12,3.48-5.19,3.62l-.1.23.23.1.76.34.22.1.11-.23s1.28-2.76,4-2.84h.25v-.25l0-.83v-.25Z"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M285.13,117c.69,2.81,3.78,3.5,3.81,3.5l-.17.81c-.15,0-3.63-.79-4.44-4.11l.8-.2m.18-.3-.24.06-.8.19L284,117l.06.25c.85,3.47,4.48,4.26,4.64,4.29l.24.06.05-.25.17-.81.05-.24-.24,0s-3-.68-3.62-3.32l-.06-.24Z"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M309.39,159.46l-11.95-6-11.5-6.59-3.35-4.07.66-3.12,1.87-.68,13.66,6.42,12.45,3.87,1.11,1.67Zm-22.68-13.37L298,152.5,308.78,158l2.37-6.86-.6-.9-12.16-3.79-13.33-6.26-.89.33-.42,2Z"
});

var _ref116 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M352.83,141.1a20.4,20.4,0,0,1,6.71,3.56,21.18,21.18,0,0,1,4.21,5.52L389.83,164l-8,1.83S362.88,156.28,360.5,154s-11.7-9.59-11.7-9.59l-2.2-6.32Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M381.76,166.4l-.17-.09c-.78-.39-19-9.61-21.45-11.88s-11.58-9.48-11.67-9.56l-.12-.09-2.68-7.69L353,140.6a20.72,20.72,0,0,1,6.85,3.65,21.07,21.07,0,0,1,4.27,5.53l27.2,14.43Zm-32.5-22.27c1.15.91,9.37,7.41,11.61,9.52,1.82,1.71,14.45,8.29,21,11.61l6.4-1.46-24.94-13.22-.08-.15a20.57,20.57,0,0,0-4.09-5.35,19.64,19.64,0,0,0-6.5-3.46l-.09,0-5.07-2.42Z"
}));

var _ref117 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M324.05,167l2.53,3.52a13.9,13.9,0,0,0,4.94,4.23l4.16,2.12,1.68-3.53-3.73-6Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M335.93,177.59l-4.66-2.37a14.48,14.48,0,0,1-5.12-4.4L323,166.41l11,.43,4,6.46Zm-10.8-10,1.89,2.62a13.28,13.28,0,0,0,4.74,4.07l3.67,1.87,1.32-2.76-3.42-5.48Z"
}));

var _ref118 = /*#__PURE__*/React.createElement("path", {
  d: "M398.51,248.06h-6.87c-4.58-20-27.92-48.9-28.15-49.16l-.1-.11-1.78-9,9.31,0,.16.2,27.43,34.4Zm-34.12-49.75c1.62,1.88,24.16,30.12,28.65,49.75h5.47V227l-28.1-36.08-7.49,0Z"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  d: "M356.82,197.68a15.28,15.28,0,0,1-8.42-11.17c-.67-3.78-2.23-8.8-5.89-11.29-4.09-2.78-11-4.92-16.56-6.64a72,72,0,0,1-7.92-2.74l-.19-.09a32,32,0,0,1-9.15-6.69l-.17-.19,1.43-10,.07-.11s2.64-3.76,2.15-7.87-6.21-7.4-6.27-7.43l-.3-.18.51-5.08,13.38,7.33L318,147.63l6.21,5.33,13,5.55,21.07,10,.08.2c1.22,3,5.2,12.7,5.17,13.76.16.72,4.05,5.66,7.7,10l.33.39-6.5,6.11-.19,0c-.32,0-.64.06-.95.07A14.47,14.47,0,0,1,356.82,197.68Zm-17.25-25.34a27.73,27.73,0,0,1,3.54,2c4,2.7,5.64,8,6.34,12A14,14,0,0,0,363.86,198l.73,0,5.49-5.17c-3-3.58-7.66-9.29-7.63-10.32,0-.82-3.06-8.41-5-13.13l-20.67-9.86-13.11-5.59-6.77-5.82,1.45-11.93L307,129.94l-.28,2.79c1.26.79,6,4,6.5,8.06a13.64,13.64,0,0,1-2.26,8.5l-1.33,9.23a31.35,31.35,0,0,0,8.84,6.35,71.8,71.8,0,0,0,7.78,2.68A106.48,106.48,0,0,1,339.57,172.34Z"
});

var _ref120 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M398.53,210.32l-20.87-19.24s-.56.54-1.4,1.4l1.09,6.13,5.63,12,15.55,17.43Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M398.51,228.25l-16-17.38-5.67-12.17-1.14-6.4.19-.2c.85-.87,1.43-1.41,1.43-1.41l.36-.34.37.34,20.48,18.89Zm-15.08-17.91,15.08,17.91,0-17.93-20.86-18.5-.84.84,1,5.78Z"
}));

var _ref121 = /*#__PURE__*/React.createElement("path", {
  d: "M388.76,227.86a1.91,1.91,0,0,1-.27-.16,2,2,0,0,1-.89-1.34,2.11,2.11,0,0,1,3.25-2.15,2.16,2.16,0,0,1,.89,1.35,2.12,2.12,0,0,1-1.67,2.47A2.18,2.18,0,0,1,388.76,227.86Zm1.35-2.84a1.08,1.08,0,0,0-.64-.08,1,1,0,0,0,.39,2,1,1,0,0,0,.66-.43,1,1,0,0,0,.16-.78h0a1,1,0,0,0-.43-.66Z"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  d: "M391.14,231.89l-.28-.16a2.1,2.1,0,0,1-.56-2.93,2.06,2.06,0,0,1,1.34-.88,2.1,2.1,0,0,1,2.15,3.24,2.12,2.12,0,0,1-2.65.73Zm1.35-2.84a1.08,1.08,0,0,0-.64-.08,1,1,0,0,0-.66.43,1,1,0,0,0-.16.78,1,1,0,0,0,.43.66,1.07,1.07,0,0,0,.78.16,1,1,0,0,0,.82-1.21A1.06,1.06,0,0,0,392.49,229.05Z"
});

var _ref123 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M387.08,183.75l1.33-1.21c2.8-2.55,10.1-5.11,10.1-5.11V170.1l-3.84-.88q-.33-.85-.63-1.83a3.8,3.8,0,0,0-2-2.32,23.12,23.12,0,0,0-8.44-2.19l-8.07,17.34L361,177.43l-3.24,1-.9-1.64-1.79,2.47-.1,1.39a6.87,6.87,0,0,0,3.9,6.74l-.66,3.52a7.48,7.48,0,0,0,6.33,2.72,16.21,16.21,0,0,1,4.83.48l3.41,8.45-2.11,3.05a1.62,1.62,0,0,0,.28,2.15l12.59,10.83,8.17-.75a3.32,3.32,0,0,0,2.41-1.38l.9-1.23-3-1.58a6.85,6.85,0,0,0-4.14-2.84l-2.14-.5-6.69-11.85.09-.61a21.74,21.74,0,0,1,5.07-11.18A37.27,37.27,0,0,1,387.08,183.75Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M383.36,219.16l-12.76-11a2.16,2.16,0,0,1-.37-2.87l1.94-2.8L369,194.58a15.16,15.16,0,0,0-4.41-.4,8,8,0,0,1-6.78-2.93l-.15-.19.63-3.37a7.47,7.47,0,0,1-3.84-7.07l.12-1.55,2.37-3.27,1.1,2,3-.91,14.28,2.74,8-17.3.37,0a23.57,23.57,0,0,1,8.64,2.25h0a4.36,4.36,0,0,1,2.26,2.64q.24.81.51,1.53l3.44.79v9.06c.29-.08-6.86,1.85-9.74,4.33-.43.37-.86.78-1.32,1.2h0a35.34,35.34,0,0,0-2.8,2.9,21,21,0,0,0-4.95,10.9l-.06.42,6.49,11.49,1.91.44a7.41,7.41,0,0,1,4.38,3l3.39,1.8-1.25,1.74a3.88,3.88,0,0,1-2.8,1.59Zm-13.59-25.49,3.61,9-2.27,3.28a1.07,1.07,0,0,0,.19,1.44l12.42,10.69,7.94-.74a2.81,2.81,0,0,0,2-1.15l.53-.74-2.54-1.35-.08-.11a6.29,6.29,0,0,0-3.81-2.62l-2.37-.55-6.89-12.22.11-.78a22.16,22.16,0,0,1,5.2-11.46,35.67,35.67,0,0,1,2.88-3c.46-.43.91-.83,1.33-1.21,2.89-2.62,6.54-5.18,10.46-5.24v-6l-4.25-1.25-.1-.27c-.21-.58-.43-1.2-.63-1.86a3.24,3.24,0,0,0-1.7-2h0a22.35,22.35,0,0,0-7.88-2.12l-8.09,17.39L361,178l-3.53,1.09-.7-1.28-1.2,1.66-.1,1.24a6.4,6.4,0,0,0,3.6,6.22l.37.17-.68,3.68a7,7,0,0,0,5.71,2.34,16.61,16.61,0,0,1,5,.49Z"
}));

var _ref124 = /*#__PURE__*/React.createElement("path", {
  d: "M385.15,216.69l-12.77-11a2.16,2.16,0,0,1-.37-2.87L374,200l-3.19-7.93a15.55,15.55,0,0,0-4.41-.4,8,8,0,0,1-6.78-2.93l-.16-.19.63-3.36a7.46,7.46,0,0,1-3.83-7.08l.13-1.76,6.41-2L377,177.14l5.81-15.43.07-.08c2.23-2.37,8.41-.84,11.22.5a4.31,4.31,0,0,1,2.25,2.62c.16.54.34,1.06.52,1.55l1.64.37,0,8.32c-2.8,0-3.78,2-5.87,3.92l-1.29,1.18-1.4,1.23c-1.25,1.09-3,2.57-3.54,3.25a21.17,21.17,0,0,0-4.94,10.9l-.35,2.42,6.74,9.49,1.94.45a7.41,7.41,0,0,1,5.73,7.42v.48Zm-13.6-25.49,3.62,9-2.27,3.28a1.08,1.08,0,0,0,.18,1.44l12.42,10.69,9-.83a6.36,6.36,0,0,0-4.9-5.88l-2.34-.54L380,198.16l.4-2.84a22.24,22.24,0,0,1,5.2-11.46c.64-.73,2.31-2.18,3.65-3.35l1.38-1.21,1.29-1.18c2.28-2.07,3.53-3.08,6.59-3.13h0l0-7.22-2.45-.56-.1-.27c-.23-.61-.44-1.25-.64-1.87a3.28,3.28,0,0,0-1.68-2c-2.61-1.24-8.09-2.54-9.91-.8l-6,16.07-14.87-2.84-5.45,1.68-.08,1a6.38,6.38,0,0,0,3.6,6.22l.37.18-.69,3.67a7,7,0,0,0,5.72,2.34,16.34,16.34,0,0,1,5,.5Z"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  d: "M341.48,170.59a2.36,2.36,0,0,1-.91-.75L339.19,168l2-8.8.08-.11,5.18-5.88,11.09-8.27.15,0a4.81,4.81,0,0,1,4.75,2.67l1.33,2.76,19.77,11.23c.29.21,5.84,4.37,6.19,9.72a8.83,8.83,0,0,1-3.1,7c-8.21,7.89-21.62,2.73-22.19,2.51l-8.09-3.64,0-.31c0-.15-.41-3.69-5.08-6a8.66,8.66,0,0,0-7.69-.19A2.44,2.44,0,0,1,341.48,170.59Zm-1.13-2.88,1.08,1.5a1.37,1.37,0,0,0,1.69.42,9.73,9.73,0,0,1,8.61.21c4.45,2.25,5.42,5.55,5.62,6.59l7.51,3.38c.11,0,13.32,5.12,21-2.29a7.77,7.77,0,0,0,2.76-6.2c-.31-4.86-5.64-8.85-5.7-8.89l-20-11.37L361.47,148a3.7,3.7,0,0,0-3.53-2.08L347.13,154l-5,5.66Z"
});

var _ref126 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M358.4,151.65s.82-1.72,1.13-2.37a.28.28,0,0,0-.13-.37l-4.56-2.43c-2.92-2.44-8.7-8-11-15.84a12.64,12.64,0,0,0-5.88-5.39l-5.94-.09-11.47,6.9-1.85-.21s-1.62,3.28-1.72,3.73l-2.25,10.57,8.93,15.57s6.33,7.59,14.16,6.75l5.47-1.83a.69.69,0,0,0,.21-.17l1.21-2.56-.54-.73.15-.76,10.89-10.36,2.89-.25a.67.67,0,0,0,.25-.13Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M330.44,167.58a23.25,23.25,0,0,1-7.16-5.51l-.06-.08-9-15.75,2.29-10.77c.1-.48,1.37-3.07,1.76-3.86l.17-.34,2,.24,11.44-6.89,6.21.09.11.05a13,13,0,0,1,6.14,5.66c2.22,7.58,7.69,13,10.78,15.61l4.51,2.41a.81.81,0,0,1,.36,1.07l-.06.13c-.75,1.6-1,2.08-1.07,2.24v0l-.06.12-.1.08a1.13,1.13,0,0,1-.53.23l-2.71.24L344.85,162.7l-.07.35.59.8L344,166.76l-.05.06a1.11,1.11,0,0,1-.45.32L337.91,169A13.89,13.89,0,0,1,330.44,167.58Zm-6.31-6.17c.47.54,6.44,7.26,13.61,6.53l5.34-1.79,1-2.18-.49-.66.23-1.16L344,162l11-10.49,3-.27c.18-.36.7-1.47,1-2l-4.44-2.38c-3.18-2.66-8.86-8.28-11.14-16.1h0a12.42,12.42,0,0,0-5.5-5l-5.67-.08-11.49,6.92-1.65-.19c-.72,1.46-1.45,3-1.51,3.27l-2.21,10.36Z"
}));

var _ref127 = /*#__PURE__*/React.createElement("path", {
  d: "M331.6,165.16a23.31,23.31,0,0,1-7.17-5.52l-.05-.07-9-15.75,2-9.28a7.75,7.75,0,0,1,3.59-5l12.14-7.31,6.21.09.1,0a13.11,13.11,0,0,1,6.15,5.66c3,10.39,12.43,16.9,12.53,17l.1.07,1.92,3.5a.94.94,0,0,1,0,.89.91.91,0,0,1-.74.49l-2.71.24L346,160.27l-.73,3.74a.93.93,0,0,1-.63.71l-5.58,1.86A13.76,13.76,0,0,1,331.6,165.16ZM325.29,159c.46.54,6.44,7.26,13.6,6.53l5.34-1.79.78-4,.13-.12,11-10.49,2.87-.25-1.7-3.09c-1.12-.8-9.84-7.21-12.82-17.41h0a12.36,12.36,0,0,0-5.49-5l-5.67-.08-11.88,7.15a6.73,6.73,0,0,0-3.1,4.34l-1.88,8.87Z"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  d: "M357.34,149.16c-9.78-4.66-18.21-19-18.58-19.6l.93-.54c.09.16,9.64,16.36,19.77,19.86l-.35,1A16.53,16.53,0,0,1,357.34,149.16Z"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  d: "M342.54,164.09c-9.24-4.4-19.52-25.56-20-26.51l1-.47c.12.25,11.92,24.52,21.07,26.58l-.23,1.05A9,9,0,0,1,342.54,164.09Z"
});

var _ref130 = /*#__PURE__*/React.createElement("rect", {
  x: 375.59,
  y: 147.3,
  width: 1.07,
  height: 30.51,
  transform: "translate(40.26 397.26) rotate(-58.32)"
});

var _ref131 = /*#__PURE__*/React.createElement("rect", {
  x: 364.32,
  y: 158.55,
  width: 1.07,
  height: 28.75,
  transform: "translate(-0.56 344.65) rotate(-50.53)"
});

var _ref132 = /*#__PURE__*/React.createElement("polygon", {
  points: "398.37 200.47 391.21 194.28 391.91 193.46 398.38 199.06 398.37 200.47"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  d: "M355.65,177.77l.66.49-.86,1.2c-.2.6-1.64,5.54,3.57,7.55l.32.13-.69,3.67a7.42,7.42,0,0,0,5.34,2.44,43.8,43.8,0,0,1,5,.36l-.16.81a46.56,46.56,0,0,0-4.88-.35,8.72,8.72,0,0,1-3.41-.82,7.25,7.25,0,0,1-2.67-2.1l-.1-.14.63-3.36c-5.76-2.47-3.74-8.46-3.71-8.52l0-.06.94-1.3m-.06-.35-.15.21-.94,1.3,0,0v0l0,.06s-2,6.15,3.67,8.75l-.59,3.16,0,.11.06.09.1.14a7.56,7.56,0,0,0,2.77,2.17,8.92,8.92,0,0,0,3.5.85,46.69,46.69,0,0,1,4.85.35l.24,0,.05-.24.15-.81,0-.24-.24,0a45.12,45.12,0,0,0-5-.37,7.13,7.13,0,0,1-5.08-2.27l.66-3.55,0-.2-.19-.07-.32-.13c-4.9-1.89-3.65-6.52-3.44-7.21l.85-1.17.14-.2-.2-.15-.67-.48-.2-.15Z"
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  d: "M338.78,179.38a2.09,2.09,0,0,1-1.16-1.5,2.06,2.06,0,0,1,.32-1.58,2.13,2.13,0,0,1,1.35-.89,2.11,2.11,0,0,1,1.58.33,2.06,2.06,0,0,1,.88,1.34,2.1,2.1,0,0,1-1.67,2.47A2.05,2.05,0,0,1,338.78,179.38Zm1.35-2.83a1,1,0,0,0-.64-.08,1,1,0,1,0,1.21.82,1,1,0,0,0-.44-.66Z"
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  d: "M311.47,162.2a4.27,4.27,0,0,1-2.48-4,1.18,1.18,0,0,1,.19-.69l.85-1.15.72-4.6.3-1.36a1.22,1.22,0,0,1,1.37-.89,1.54,1.54,0,0,1,1.33,1.14l.88,4.39,1.26,4.82a4.6,4.6,0,0,1-.89,3,.82.82,0,0,1-.8.28,14,14,0,0,1-2.57-.85Zm-1.39-4.08a.49.49,0,0,0,0,.14,3.21,3.21,0,0,0,2,3,13.93,13.93,0,0,0,2.23.75,4.41,4.41,0,0,0,.57-1.9l-1.26-4.79-.9-4.46a.44.44,0,0,0-.39-.29.2.2,0,0,0-.2.05l-.29,1.31-.54-.08.53.09-.7,4.56a1.16,1.16,0,0,1-.21.5Z"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  d: "M289.33,149.12a5,5,0,0,1-.5-.29l-3.58-2.4a3.48,3.48,0,0,1-1.05-1.08L282,141.63a2.08,2.08,0,0,1,0-2.35l.5-.67a2.35,2.35,0,0,1,2.35-.79l.5.09a3.68,3.68,0,0,1,1.37.51l6.71,4.16a3.07,3.07,0,0,1,1.53,2.21,1.8,1.8,0,0,1-.57,1.55l-.51.47a.75.75,0,0,0-.14.17l-.9,1.52a2,2,0,0,1-1.32.91A3.34,3.34,0,0,1,289.33,149.12Zm-6-9.87-.5.67a1,1,0,0,0,.07,1.15l2.25,3.73a2.45,2.45,0,0,0,.73.74l3.58,2.4a2.42,2.42,0,0,0,1.79.42,1,1,0,0,0,.64-.41l.9-1.52a1.86,1.86,0,0,1,.33-.41l.51-.46a.75.75,0,0,0,.23-.66,2,2,0,0,0-1-1.41l-6.71-4.15a2.77,2.77,0,0,0-1-.38l-.5-.08A1.36,1.36,0,0,0,283.3,139.25Z"
});

var _ref137 = /*#__PURE__*/React.createElement("polygon", {
  points: "293.15 146.86 286.5 142.38 285.68 140.85 286.62 140.34 287.32 141.64 293.75 145.97 293.15 146.86"
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  d: "M305.22,158.27l-9.69-5.35a2.25,2.25,0,0,1-1.36-1.7l-.09-.82a1.6,1.6,0,0,1,.09-.81l1.22-3.11a1.54,1.54,0,0,1,.23-.39l.82-1.06a2.1,2.1,0,0,1,2.35-.53l8.22,2.81a2.56,2.56,0,0,1,1.42,1.15l.77,1.39a1.85,1.85,0,0,1,.25,1l-.28,5a1.58,1.58,0,0,1-.34.89l-1,1.11A2.13,2.13,0,0,1,305.22,158.27ZM296,152l9.69,5.34a1.11,1.11,0,0,0,1.28-.13l1-1.11a.47.47,0,0,0,.07-.25l.29-5a.91.91,0,0,0-.11-.43l-.78-1.39a1.55,1.55,0,0,0-.83-.66l-8.22-2.8a1,1,0,0,0-1.15.18l-.83,1.06a.35.35,0,0,0-.07.12l-1.22,3.1a.53.53,0,0,0,0,.28l.09.83A1.19,1.19,0,0,0,296,152Z"
});

var _ref139 = /*#__PURE__*/React.createElement("polygon", {
  points: "299.27 148.62 299.71 147.64 306.57 150.68 308.82 150.3 309 151.36 306.43 151.79 299.27 148.62"
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  d: "M292,136.12a1.41,1.41,0,0,1-.66-.66l-.49-1a1.41,1.41,0,0,1,0-1.19l3-6.35a1,1,0,0,1,.17-.28l1.73-2.11a1.38,1.38,0,0,1,1.58-.41l.59.24a1.36,1.36,0,0,1,.78,1.76l-.59,1.62a.31.31,0,0,0,0,.25l1.72,3.33a1.39,1.39,0,0,1-.14,1.48l-1.12,1.45a.44.44,0,0,0-.06.16l-.23,1.71a1.42,1.42,0,0,1-.58,1,1.39,1.39,0,0,1-1.1.2l-4.38-1A1.15,1.15,0,0,1,292,136.12Zm5.58-10.8h0l-.58-.23a.32.32,0,0,0-.36.09l-1.77,2.17-3,6.36a.3.3,0,0,0,0,.26l.49,1a.3.3,0,0,0,.21.17l4.38,1a.29.29,0,0,0,.25,0,.32.32,0,0,0,.13-.21l.22-1.72a1.44,1.44,0,0,1,.28-.66l1.12-1.46a.29.29,0,0,0,0-.33l-1.72-3.33a1.39,1.39,0,0,1-.07-1.11l.59-1.62A.31.31,0,0,0,297.53,125.32Z"
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  d: "M295.73,145.11l-3.35-2.06a1.36,1.36,0,0,1-.6-.81l-.81-2.93a1.42,1.42,0,0,1,.28-1.27,1.38,1.38,0,0,1,1.21-.47l3.19.34a1.4,1.4,0,0,1,1.23,1.51l-.36,3.81a1.31,1.31,0,0,1-.12.47ZM292,139l.8,2.93a.3.3,0,0,0,.14.19l2.32,1.42.16-.32a.36.36,0,0,0,0-.1l.36-3.82a.32.32,0,0,0-.28-.34l-3.19-.35a.31.31,0,0,0-.33.39Z"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  d: "M301,130.35a1.7,1.7,0,0,1-.94-1.2l-.56-2.73a1.71,1.71,0,0,1,.13-1.09l1.38-2.9a1.72,1.72,0,0,1,1.41-1l8.82-.76a1.61,1.61,0,0,1,.78.11l8.45,3.3a1.76,1.76,0,0,1,1.08,1.41,1.71,1.71,0,0,1-.73,1.62l-5.16,3.55a.63.63,0,0,0-.22.26l-.8,1.68a1.72,1.72,0,0,1-2.14.88l-5.79-2.08-.11,0-5.14-.89A1.77,1.77,0,0,1,301,130.35Zm19.12-5.23-.05,0-8.44-3.3a.61.61,0,0,0-.3,0l-8.82.76a.65.65,0,0,0-.53.37l-1.38,2.9a.58.58,0,0,0-.05.41l.56,2.73a.66.66,0,0,0,.53.51l5.15.9a1.53,1.53,0,0,1,.29.07l5.78,2.08a.65.65,0,0,0,.81-.33l.8-1.69a1.71,1.71,0,0,1,.58-.67l5.16-3.55a.67.67,0,0,0,.28-.61A.67.67,0,0,0,320.12,125.12Z"
});

var _ref143 = /*#__PURE__*/React.createElement("path", {
  d: "M289.06,118.32a2.44,2.44,0,0,1-1.12-1.06,2.37,2.37,0,0,1-.12-2,1.17,1.17,0,0,1,.25-.42l.55-.64a4.62,4.62,0,0,1,4-1.58l6.92.73a1.42,1.42,0,0,1,.19,2.8l-2.36.57a.33.33,0,0,0-.24.19l-.92,1.94a1.41,1.41,0,0,1-1.61.77l-5-1.14A2.28,2.28,0,0,1,289.06,118.32Zm10.47-3.85-.11,0-6.92-.74a3.55,3.55,0,0,0-3.07,1.22l-.55.64a.24.24,0,0,0-.06.09,1.32,1.32,0,0,0,.07,1.1,1.39,1.39,0,0,0,.92.7l5,1.14a.34.34,0,0,0,.39-.19l.92-1.94a1.47,1.47,0,0,1,1-.77l2.37-.56a.39.39,0,0,0,.23-.19.36.36,0,0,0,0-.32A.33.33,0,0,0,299.53,114.47Z"
});

var _ref144 = /*#__PURE__*/React.createElement("path", {
  d: "M300.63,121.25a2.27,2.27,0,0,1-.56-.37,2.44,2.44,0,0,1-.86-1.74,2.5,2.5,0,0,1,.24-1.21l.64-1.35a2.47,2.47,0,0,1,.92-1l2.53-1.61a2.53,2.53,0,0,1,1.65-.37l7.76,1a2.56,2.56,0,0,1,1.42.68l.25.24a2.5,2.5,0,0,1,.08,3.51l-1,1a2.52,2.52,0,0,1-1.61.78l-3.81.3-2.56.05-3.81.33A2.48,2.48,0,0,1,300.63,121.25Zm12.62-5.52a1.32,1.32,0,0,0-.43-.12l-7.76-1a1.47,1.47,0,0,0-.94.21l-2.54,1.62a1.49,1.49,0,0,0-.52.59l-.64,1.34a1.35,1.35,0,0,0-.13.69,1.4,1.4,0,0,0,.48,1,1.43,1.43,0,0,0,1.06.35l3.81-.33h.17l2.55,0,3.65-.3a1.46,1.46,0,0,0,.92-.44l1-1.06a1.42,1.42,0,0,0,0-2l-.26-.24A1.64,1.64,0,0,0,313.25,115.73Z"
});

var _ref145 = /*#__PURE__*/React.createElement("path", {
  d: "M321.38,124.74a1.69,1.69,0,0,1-.29-.17l-2.35-1.63a1,1,0,0,0-.18-.1l-2.42-1a2,2,0,0,1-.73-3.23l1-1.09a2,2,0,0,1,1.12-.63l1.27-.24a2,2,0,0,1,1.08.09l6.49,2.41a2,2,0,0,1,.26,3.67l-3.42,1.86A2,2,0,0,1,321.38,124.74Zm-2.31-2.85a2.61,2.61,0,0,1,.28.17l2.35,1.63a.93.93,0,0,0,1,.06l3.43-1.86a.95.95,0,0,0,.32-1.38.91.91,0,0,0-.44-.34l-6.49-2.42a1,1,0,0,0-.51,0l-1.27.24a1,1,0,0,0-.53.3l-1,1.09a1,1,0,0,0-.23.85.94.94,0,0,0,.57.67l2.42,1Z"
});

var _ref146 = /*#__PURE__*/React.createElement("path", {
  d: "M316.57,116.09a1.67,1.67,0,0,1-.9-1.88l.05-.24a1.66,1.66,0,0,1,.74-1l3.15-2a1.69,1.69,0,0,1,.65-.23l3.61-.5a1.68,1.68,0,0,1,1.05.21l4.22,2.4a1.72,1.72,0,0,1,.71.8l.49,1.16a1.66,1.66,0,0,1-2.89,1.61l-.31-.43a.59.59,0,0,0-.73-.19l-3.21,1.51a1.73,1.73,0,0,1-1.1.12l-5.2-1.23Zm7.78-4.72a.54.54,0,0,0-.33-.05l-3.61.49a.57.57,0,0,0-.23.08l-3.15,2a.56.56,0,0,0-.26.37l-.06.23a.6.6,0,0,0,.44.71l5.2,1.23a.58.58,0,0,0,.39,0l3.21-1.51a1.66,1.66,0,0,1,2.07.54l.3.43a.56.56,0,0,0,.42.24.58.58,0,0,0,.54-.23.6.6,0,0,0,.07-.58l-.49-1.16a.64.64,0,0,0-.25-.29l-4.22-2.4Z"
});

var _ref147 = /*#__PURE__*/React.createElement("path", {
  d: "M333.23,119.81a1.58,1.58,0,0,1-.39-.24l-.93-.72a2.11,2.11,0,0,1-.8-1.68,2.08,2.08,0,0,1,2.18-2.07l2.46.09a2.07,2.07,0,0,1,1.58.82l1.12,1.46a2.14,2.14,0,0,1-2.37,3.3l-2.61-.86Zm2.88-3.45a1.12,1.12,0,0,0-.4-.1l-2.46-.09a1,1,0,0,0-.75.28,1,1,0,0,0,.07,1.55l.93.73a.83.83,0,0,0,.31.16l2.6.86a1,1,0,0,0,.93-.15,1,1,0,0,0,.25-1.48l-1.11-1.45A1,1,0,0,0,336.11,116.36Z"
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  d: "M328.5,122.65l.4.72-4.44,2.51-.41-.72,4.45-2.51m.09-.34-.21.12-4.45,2.51-.22.12.12.22.41.72.12.22.22-.13,4.45-2.5.21-.12-.12-.22-.4-.72-.13-.22Z"
});

var _ref149 = /*#__PURE__*/React.createElement("path", {
  d: "M320.85,127.61l.51.64-3.86,3.06-.51-.65,3.86-3m0-.35-.2.15-3.86,3.06-.19.15.15.2.52.64.15.2.2-.15,3.86-3.06.19-.16-.15-.19-.52-.65-.15-.19Z"
});

var _ref150 = /*#__PURE__*/React.createElement("path", {
  d: "M334.14,120.66l0,.83-3.81.08,0-.82,3.81-.09m.25-.26h-.25l-3.82.09h-.25v.25l0,.83v.25h.25l3.82-.08h.25v-.25l0-.83v-.25Z"
});

var _ref151 = /*#__PURE__*/React.createElement("path", {
  d: "M327.3,116.11l.37.74-1.9,1-.37-.74,1.9-1m.11-.33-.23.11-1.89,1-.22.11.11.23.37.73.11.23.23-.12,1.89-1L328,117l-.11-.22-.37-.74-.11-.22Z"
});

var _ref152 = /*#__PURE__*/React.createElement("path", {
  d: "M312.37,134.43a10.68,10.68,0,0,1,3,5.51l-.81.14a10.13,10.13,0,0,0-2.71-5.05l.56-.6m0-.36-.17.19-.56.6-.18.18.19.17a9.8,9.8,0,0,1,2.63,4.91l.05.25.24,0,.82-.14.24,0,0-.25a11.14,11.14,0,0,0-3-5.66l-.19-.17Z"
});

var _ref153 = /*#__PURE__*/React.createElement("path", {
  d: "M304.47,128l0-1.08,1.57.06a10.66,10.66,0,0,1,4.48,1.15l1.33.58-.44,1-1.35-.59A10,10,0,0,0,306,128Z"
});

var _ref154 = /*#__PURE__*/React.createElement("rect", {
  x: 294.19,
  y: 129.66,
  width: 5.05,
  height: 1.07,
  transform: "translate(24.32 305.67) rotate(-56.48)"
});

var _ref155 = /*#__PURE__*/React.createElement("rect", {
  x: 294,
  y: 113.04,
  width: 1.07,
  height: 5.46,
  transform: "translate(132.52 387.63) rotate(-80.67)"
});

var _ref156 = /*#__PURE__*/React.createElement("rect", {
  x: 311.51,
  y: 115.74,
  width: 1.07,
  height: 4.66,
  transform: "translate(125.2 394.47) rotate(-76.67)"
});

var _ref157 = /*#__PURE__*/React.createElement("path", {
  d: "M291,121.36l2.85,1.21-.33.76-2.85-1.21.33-.76m-.14-.33-.09.23-.33.76-.09.23.23.1,2.85,1.21.23.1.09-.23.33-.76.1-.23-.23-.1-2.86-1.21-.23-.1Z"
});

var _ref158 = /*#__PURE__*/React.createElement("polyline", {
  points: "390.33 218.72 398.51 228.25 398.53 225.98"
});

var _ref159 = /*#__PURE__*/React.createElement("path", {
  d: "M166.15,133.24l26.35,38.49-3.72,2.55-26-38.64,3.36-2.4m.13-.71-.42.3-3.36,2.4-.4.28.27.41,26,38.64.28.42.42-.28,3.72-2.55.42-.29-.29-.41L166.57,133l-.29-.43Z"
});

function SvgCopypageImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 398.53 248.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M165.63,139.34l-1.18.09a.44.44,0,0,1-.36-.19l-.63-.92c-.08-.12-.05-.22.07-.23l1.18-.09a.48.48,0,0,1,.37.19l.63.92C165.79,139.23,165.75,139.33,165.63,139.34Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.74,139.57l-1.18.09a.48.48,0,0,1-.37-.19l-.63-.92c-.08-.12,0-.22.08-.23l1.18-.09a.47.47,0,0,1,.36.19l.63.92C162.89,139.46,162.86,139.56,162.74,139.57Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.19,141.61l-1.18.09a.44.44,0,0,1-.36-.19l-.63-.92c-.08-.11-.05-.22.07-.23l1.18-.09a.47.47,0,0,1,.37.19l.63.92C167.35,141.5,167.32,141.6,167.19,141.61Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.3,141.84l-1.18.09a.42.42,0,0,1-.36-.19l-.64-.92c-.08-.12,0-.22.08-.23l1.18-.09a.47.47,0,0,1,.36.19l.63.92C164.45,141.73,164.42,141.83,164.3,141.84Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.85,144l-1.18.1a.47.47,0,0,1-.37-.2l-.63-.92c-.08-.11,0-.21.08-.22l1.18-.09a.44.44,0,0,1,.36.19l.63.92C169,143.9,169,144,168.85,144Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,144.24l-1.18.1a.45.45,0,0,1-.36-.2l-.63-.92c-.08-.11-.05-.21.07-.22l1.18-.1a.47.47,0,0,1,.37.2l.63.92C166.11,144.13,166.07,144.23,166,144.24Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.41,146.28l-1.18.1a.47.47,0,0,1-.36-.19l-.64-.92c-.08-.12,0-.22.08-.23l1.18-.09a.44.44,0,0,1,.36.19l.64.92C170.56,146.17,170.53,146.28,170.41,146.28Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.51,146.51l-1.18.1a.45.45,0,0,1-.36-.2l-.63-.92c-.08-.11-.05-.21.07-.22l1.18-.09a.44.44,0,0,1,.37.19l.63.92C167.67,146.4,167.64,146.5,167.51,146.51Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,148.56l-1.18.09a.47.47,0,0,1-.36-.19l-.63-.92c-.08-.12-.05-.22.07-.23l1.18-.09a.42.42,0,0,1,.36.19l.64.92C172.13,148.45,172.09,148.55,172,148.56Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.08,148.78l-1.18.1a.47.47,0,0,1-.37-.19l-.63-.92c-.08-.12-.05-.22.08-.23l1.18-.09a.44.44,0,0,1,.36.19l.63.92C169.23,148.67,169.2,148.78,169.08,148.78Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.62,151l-1.18.09a.44.44,0,0,1-.36-.19l-.63-.92c-.08-.11,0-.22.07-.23l1.18-.09a.47.47,0,0,1,.37.19l.63.92C173.78,150.85,173.75,151,173.62,151Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.73,151.19l-1.18.09a.44.44,0,0,1-.36-.19l-.64-.92c-.08-.12,0-.22.08-.23l1.18-.09a.47.47,0,0,1,.36.19l.64.92C170.88,151.08,170.85,151.18,170.73,151.19Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.19,153.23l-1.18.09a.44.44,0,0,1-.37-.19l-.63-.92c-.08-.11,0-.21.08-.22l1.18-.1a.47.47,0,0,1,.36.19l.63.92C175.34,153.12,175.31,153.22,175.19,153.23Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.29,153.46l-1.18.09a.44.44,0,0,1-.36-.19l-.64-.92c-.07-.11,0-.22.08-.23l1.18-.09a.47.47,0,0,1,.36.19l.64.92C172.45,153.35,172.41,153.45,172.29,153.46Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.75,155.5l-1.18.1a.44.44,0,0,1-.36-.2l-.64-.92c-.08-.11,0-.21.08-.22l1.18-.1a.45.45,0,0,1,.36.2l.63.92C176.9,155.39,176.87,155.49,176.75,155.5Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.85,155.73l-1.18.09a.44.44,0,0,1-.36-.19l-.63-.92c-.08-.11-.05-.21.07-.22l1.18-.1a.48.48,0,0,1,.37.19l.63.92C174,155.62,174,155.72,173.85,155.73Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.4,157.91l-1.18.09a.47.47,0,0,1-.36-.19l-.63-.92c-.08-.12,0-.22.07-.23l1.18-.09a.42.42,0,0,1,.36.19l.64.92C178.56,157.8,178.52,157.9,178.4,157.91Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51,158.13l-1.18.1A.47.47,0,0,1,174,158l-.63-.92c-.08-.12-.05-.22.08-.23l1.18-.09a.44.44,0,0,1,.36.19l.63.92C175.66,158,175.63,158.13,175.51,158.13Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,160.18l-1.18.09a.47.47,0,0,1-.36-.19l-.63-.92c-.08-.12,0-.22.07-.23l1.18-.09a.48.48,0,0,1,.37.19l.63.92C180.12,160.07,180.09,160.17,180,160.18Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.07,160.41l-1.18.09a.48.48,0,0,1-.37-.19l-.63-.92c-.08-.12,0-.22.08-.23l1.18-.09a.44.44,0,0,1,.36.19l.63.92C177.22,160.3,177.19,160.4,177.07,160.41Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.53,162.45l-1.18.09a.44.44,0,0,1-.37-.19l-.63-.92c-.08-.12,0-.22.07-.23l1.19-.09a.47.47,0,0,1,.36.19l.63.92C181.68,162.34,181.65,162.44,181.53,162.45Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.63,162.68l-1.18.09a.47.47,0,0,1-.36-.19l-.64-.92c-.08-.12,0-.22.08-.23l1.18-.09a.47.47,0,0,1,.36.19l.64.92C178.79,162.57,178.75,162.67,178.63,162.68Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.18,164.85,182,165a.44.44,0,0,1-.36-.2l-.64-.92c-.08-.11,0-.21.08-.22l1.18-.1a.45.45,0,0,1,.36.2l.63.92C183.33,164.74,183.3,164.84,183.18,164.85Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.28,165.08l-1.18.09a.44.44,0,0,1-.36-.19l-.63-.92c-.08-.11-.05-.21.07-.22l1.18-.1a.48.48,0,0,1,.37.19l.63.92C180.44,165,180.4,165.07,180.28,165.08Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.74,167.12l-1.18.1a.47.47,0,0,1-.36-.19l-.64-.92c-.08-.12,0-.22.08-.23l1.18-.09a.44.44,0,0,1,.36.19l.64.92C184.9,167,184.86,167.11,184.74,167.12Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.85,167.35l-1.19.1a.45.45,0,0,1-.36-.2l-.63-.92c-.08-.11,0-.21.07-.22l1.19-.1a.45.45,0,0,1,.36.2l.63.92C182,167.24,182,167.34,181.85,167.35Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.3,169.4l-1.18.09a.47.47,0,0,1-.36-.19l-.63-.92c-.08-.12,0-.22.07-.23l1.18-.09a.46.46,0,0,1,.37.19l.63.92C186.46,169.28,186.42,169.39,186.3,169.4Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.41,169.62l-1.18.1a.48.48,0,0,1-.37-.19l-.63-.92c-.08-.12,0-.22.08-.23l1.18-.09a.44.44,0,0,1,.36.19l.63.92C183.56,169.51,183.53,169.61,183.41,169.62Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,171.8l-1.18.09a.44.44,0,0,1-.37-.19l-.63-.92c-.08-.12-.05-.22.07-.23l1.19-.09a.47.47,0,0,1,.36.19l.63.92C188.11,171.69,188.08,171.79,188,171.8Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.06,172l-1.18.09a.47.47,0,0,1-.36-.19l-.64-.92c-.08-.12,0-.22.08-.23l1.18-.09a.47.47,0,0,1,.36.19l.64.92C185.22,171.92,185.18,172,185.06,172Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.52,174.07l-1.18.09A.46.46,0,0,1,188,174l-.63-.92c-.08-.11,0-.22.08-.23l1.18-.09a.47.47,0,0,1,.36.19l.63.92C189.67,174,189.64,174.06,189.52,174.07Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.62,174.3l-1.18.09a.44.44,0,0,1-.36-.19l-.63-.92c-.08-.12,0-.22.07-.23l1.18-.09a.48.48,0,0,1,.37.19l.63.92C186.78,174.19,186.74,174.29,186.62,174.3Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.08,176.34l-1.18.09a.44.44,0,0,1-.36-.19l-.64-.92c-.08-.11,0-.21.08-.22l1.18-.1a.47.47,0,0,1,.36.19l.64.92C191.24,176.23,191.2,176.33,191.08,176.34Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.19,176.57l-1.19.09a.44.44,0,0,1-.36-.19l-.63-.92c-.08-.11,0-.22.07-.23l1.18-.09a.47.47,0,0,1,.37.19l.63.92C188.34,176.46,188.31,176.56,188.19,176.57Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.73,178.75l-1.18.09a.47.47,0,0,1-.36-.19l-.63-.92c-.08-.12-.05-.22.07-.23l1.18-.09a.46.46,0,0,1,.37.19l.63.92C192.89,178.63,192.85,178.74,192.73,178.75Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.84,179l-1.18.1a.48.48,0,0,1-.37-.19l-.63-.92c-.08-.12,0-.22.08-.23l1.18-.09a.44.44,0,0,1,.36.19l.63.92C190,178.86,190,179,189.84,179Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.3,181l-1.19.09a.47.47,0,0,1-.36-.19l-.63-.92c-.08-.12-.05-.22.07-.23l1.18-.09a.44.44,0,0,1,.37.19l.63.92C194.45,180.91,194.42,181,194.3,181Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.87,120.76l-1.18.09a.46.46,0,0,1-.37-.19l-.63-.92c-.08-.11,0-.22.08-.23l1.18-.09a.47.47,0,0,1,.36.19l.63.92C153,120.65,153,120.75,152.87,120.76Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.52,123.16l-1.18.1a.45.45,0,0,1-.36-.2l-.63-.92c-.08-.11,0-.21.07-.22l1.18-.1a.46.46,0,0,1,.36.2l.64.92C154.68,123.05,154.64,123.15,154.52,123.16Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.63,123.39l-1.18.1a.45.45,0,0,1-.37-.2l-.63-.92c-.08-.11,0-.21.08-.22l1.18-.1a.45.45,0,0,1,.36.2l.63.92C151.78,123.28,151.75,123.38,151.63,123.39Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.08,125.43l-1.18.1a.47.47,0,0,1-.36-.19l-.63-.92c-.08-.12,0-.22.07-.23l1.18-.09a.46.46,0,0,1,.37.19l.63.92C156.24,125.32,156.21,125.43,156.08,125.43Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.19,125.66l-1.18.1a.47.47,0,0,1-.37-.2l-.63-.92c-.08-.11,0-.21.08-.22l1.18-.09a.44.44,0,0,1,.36.19l.63.92C153.34,125.55,153.31,125.65,153.19,125.66Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.65,127.71l-1.18.09a.47.47,0,0,1-.37-.19l-.63-.92c-.08-.12-.05-.22.07-.23l1.19-.09a.44.44,0,0,1,.36.19l.63.92C157.8,127.6,157.77,127.7,157.65,127.71Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.75,127.93l-1.18.1a.47.47,0,0,1-.36-.19l-.64-.92c-.08-.12,0-.22.08-.23l1.18-.09a.44.44,0,0,1,.36.19l.64.92C154.91,127.82,154.87,127.93,154.75,127.93Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.3,130.11l-1.18.09a.46.46,0,0,1-.37-.19l-.63-.92c-.08-.11,0-.22.08-.23l1.18-.09a.47.47,0,0,1,.36.19l.63.92C159.45,130,159.42,130.1,159.3,130.11Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.4,130.34l-1.18.09a.44.44,0,0,1-.36-.19l-.63-.92c-.08-.12,0-.22.07-.23l1.18-.09a.48.48,0,0,1,.37.19l.63.92C156.56,130.23,156.52,130.33,156.4,130.34Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.86,132.38l-1.18.09a.44.44,0,0,1-.36-.19l-.64-.92c-.08-.11,0-.21.08-.22l1.18-.1a.47.47,0,0,1,.36.19l.64.92C161,132.27,161,132.37,160.86,132.38Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,132.61l-1.19.09a.44.44,0,0,1-.36-.19l-.63-.92c-.08-.11,0-.22.07-.23l1.19-.09a.47.47,0,0,1,.36.19l.63.92C158.12,132.5,158.09,132.6,158,132.61Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.42,134.65l-1.18.1a.45.45,0,0,1-.36-.2l-.63-.92c-.08-.11-.05-.21.07-.22l1.18-.1a.47.47,0,0,1,.37.2l.63.92C162.58,134.54,162.54,134.64,162.42,134.65Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.53,134.88l-1.18.09a.46.46,0,0,1-.37-.19l-.63-.92c-.08-.11,0-.21.08-.22l1.18-.1a.47.47,0,0,1,.36.19l.63.92C159.68,134.77,159.65,134.87,159.53,134.88Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.08,137.06l-1.18.09a.47.47,0,0,1-.37-.19l-.63-.92c-.08-.12-.05-.22.07-.23l1.19-.09a.44.44,0,0,1,.36.19l.63.92C164.23,137,164.2,137.05,164.08,137.06Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.18,137.28l-1.18.1a.47.47,0,0,1-.36-.19l-.64-.92c-.08-.12,0-.22.08-.23l1.18-.09a.44.44,0,0,1,.36.19l.64.92C161.34,137.17,161.3,137.28,161.18,137.28Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.4,181.25l-1.18.09a.47.47,0,0,1-.36-.19l-.64-.92c-.08-.12,0-.22.08-.23l1.18-.09a.44.44,0,0,1,.36.19l.64.92C191.55,181.13,191.52,181.24,191.4,181.25Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.86,183.29l-1.18.09a.48.48,0,0,1-.37-.19l-.63-.92c-.08-.12-.05-.22.08-.23l1.18-.09a.47.47,0,0,1,.36.19l.63.92C196,183.18,196,183.28,195.86,183.29Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,183.52l-1.18.09a.47.47,0,0,1-.36-.19l-.63-.92c-.08-.12,0-.22.07-.23l1.18-.09a.42.42,0,0,1,.36.19l.64.92C193.12,183.41,193.08,183.51,193,183.52Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.51,185.69l-1.18.09a.44.44,0,0,1-.36-.19l-.64-.92c-.08-.11,0-.21.08-.22l1.18-.1a.47.47,0,0,1,.36.19l.64.92C197.67,185.58,197.63,185.68,197.51,185.69Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.62,185.92l-1.19.09a.44.44,0,0,1-.36-.19l-.63-.92c-.08-.11-.05-.22.07-.23l1.18-.09a.47.47,0,0,1,.37.19l.63.92C194.77,185.81,194.74,185.91,194.62,185.92Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.07,188l-1.18.1a.45.45,0,0,1-.36-.2l-.63-.92c-.08-.11-.05-.21.07-.22l1.18-.1a.47.47,0,0,1,.37.2l.63.92C199.23,187.85,199.19,188,199.07,188Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.18,188.19l-1.18.09a.46.46,0,0,1-.37-.19l-.63-.92c-.08-.11-.05-.21.08-.22l1.18-.1a.47.47,0,0,1,.36.19l.63.92C196.33,188.08,196.3,188.18,196.18,188.19Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.63,190.23l-1.18.1a.47.47,0,0,1-.36-.19l-.63-.92c-.08-.12-.05-.22.07-.23l1.18-.09a.44.44,0,0,1,.37.19l.63.92C200.79,190.12,200.76,190.22,200.63,190.23Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.74,190.46l-1.18.1a.44.44,0,0,1-.36-.2l-.64-.92c-.08-.11,0-.21.08-.22l1.18-.1a.45.45,0,0,1,.36.2l.63.92C197.89,190.35,197.86,190.45,197.74,190.46Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.29,192.64l-1.18.09a.48.48,0,0,1-.37-.19l-.63-.92c-.08-.12,0-.22.08-.23l1.18-.09a.47.47,0,0,1,.36.19l.63.92C202.44,192.53,202.41,192.63,202.29,192.64Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.39,192.87l-1.18.09a.47.47,0,0,1-.36-.19l-.63-.92c-.08-.12-.05-.22.07-.23l1.18-.09a.42.42,0,0,1,.36.19l.64.92C199.55,192.76,199.51,192.86,199.39,192.87Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.18,192.41l-1.18.09a.44.44,0,0,1-.36-.19l-.63-.92c-.08-.12,0-.22.07-.23l1.18-.09a.48.48,0,0,1,.37.19l.63.92C205.34,192.3,205.3,192.4,205.18,192.41Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.08,192.18l-1.18.09a.46.46,0,0,1-.37-.19l-.63-.92c-.08-.11,0-.22.08-.22l1.18-.1a.47.47,0,0,1,.36.19l.63.92C208.23,192.07,208.2,192.17,208.08,192.18Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,192l-1.18.09a.44.44,0,0,1-.36-.19l-.63-.92c-.08-.11-.05-.21.07-.22l1.18-.1a.48.48,0,0,1,.37.19l.63.92C211.13,191.84,211.09,191.94,211,192Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.87,191.72l-1.18.1a.47.47,0,0,1-.37-.2l-.63-.92c-.08-.11,0-.21.08-.22l1.18-.1a.45.45,0,0,1,.36.2l.63.92C214,191.61,214,191.71,213.87,191.72Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,191.49l-1.18.1a.47.47,0,0,1-.36-.19l-.63-.92c-.08-.12-.05-.22.07-.23l1.18-.09a.46.46,0,0,1,.37.19l.63.92C216.92,191.38,216.89,191.48,216.76,191.49Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.66,191.27l-1.18.09a.45.45,0,0,1-.36-.19l-.64-.92c-.08-.12,0-.22.08-.23l1.18-.09a.44.44,0,0,1,.36.19l.63.92C219.81,191.15,219.78,191.26,219.66,191.27Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.55,191l-1.18.09a.47.47,0,0,1-.36-.19l-.63-.92c-.08-.12,0-.22.07-.23l1.18-.09a.44.44,0,0,1,.37.19l.63.92C222.71,190.93,222.68,191,222.55,191Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.45,190.81l-1.18.09a.47.47,0,0,1-.36-.19l-.64-.92c-.08-.12,0-.22.08-.23l1.18-.09a.47.47,0,0,1,.36.19l.64.92C225.6,190.7,225.57,190.8,225.45,190.81Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.35,190.58l-1.19.09a.44.44,0,0,1-.36-.19l-.63-.92c-.08-.12,0-.22.07-.23l1.18-.09a.47.47,0,0,1,.37.19l.63.92C228.5,190.47,228.47,190.57,228.35,190.58Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.24,190.35l-1.18.09a.44.44,0,0,1-.36-.19l-.64-.92c-.08-.11,0-.22.08-.22l1.18-.1a.47.47,0,0,1,.36.19l.64.92C231.4,190.24,231.36,190.34,231.24,190.35Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.14,190.12l-1.18.09a.44.44,0,0,1-.37-.19l-.63-.92c-.08-.11-.05-.21.07-.22l1.19-.1a.45.45,0,0,1,.36.2l.63.92C234.29,190,234.26,190.11,234.14,190.12Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,189.89l-1.18.1a.45.45,0,0,1-.36-.2l-.64-.92c-.07-.11,0-.21.08-.22l1.18-.1a.45.45,0,0,1,.36.2l.64.92C237.19,189.78,237.15,189.88,237,189.89Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.85,194.91l-1.18.09a.44.44,0,0,1-.36-.19l-.64-.92c-.08-.12,0-.22.08-.23l1.18-.09a.47.47,0,0,1,.36.19l.63.92C204,194.8,204,194.9,203.85,194.91Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.55,190.14l-1.18.09A.47.47,0,0,1,202,190l-.64-.92c-.08-.12,0-.22.08-.23l1.18-.09a.47.47,0,0,1,.36.19l.64.92C203.7,190,203.67,190.13,203.55,190.14Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.74,194.68l-1.18.09a.44.44,0,0,1-.36-.19l-.63-.92c-.08-.11,0-.22.07-.22l1.18-.1a.47.47,0,0,1,.37.19l.63.92C206.9,194.57,206.87,194.67,206.74,194.68Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.64,194.45l-1.18.09a.44.44,0,0,1-.36-.19l-.64-.92c-.08-.11,0-.21.08-.22l1.18-.1a.47.47,0,0,1,.36.19l.64.93C209.8,194.34,209.76,194.44,209.64,194.45Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.54,194.22l-1.19.1a.45.45,0,0,1-.36-.2l-.63-.92c-.08-.11-.05-.21.07-.22l1.19-.1a.45.45,0,0,1,.36.2l.63.92C212.69,194.11,212.66,194.21,212.54,194.22Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.43,194l-1.18.1a.47.47,0,0,1-.36-.19l-.64-.92c-.08-.12,0-.22.08-.23l1.18-.09a.44.44,0,0,1,.36.19l.64.92C215.59,193.88,215.55,194,215.43,194Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.33,193.77l-1.18.09a.47.47,0,0,1-.37-.19l-.63-.92c-.08-.12-.05-.22.07-.23l1.19-.09a.44.44,0,0,1,.36.19l.63.92C218.48,193.65,218.45,193.76,218.33,193.77Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.22,193.54l-1.18.09a.47.47,0,0,1-.36-.19l-.64-.92c-.07-.12,0-.22.08-.23l1.18-.09a.44.44,0,0,1,.36.19l.64.92C221.38,193.43,221.34,193.53,221.22,193.54Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.12,193.31l-1.18.09a.47.47,0,0,1-.37-.19l-.63-.92c-.08-.12-.05-.22.08-.23l1.18-.09a.47.47,0,0,1,.36.19l.63.92C224.27,193.2,224.24,193.3,224.12,193.31Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,193.08l-1.18.09a.44.44,0,0,1-.36-.19l-.63-.92c-.08-.12-.05-.22.07-.23l1.18-.09a.45.45,0,0,1,.36.19l.64.92C227.17,193,227.13,193.07,227,193.08Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.91,192.85l-1.18.09a.46.46,0,0,1-.37-.19l-.63-.92c-.08-.11,0-.22.08-.22l1.18-.1a.47.47,0,0,1,.36.19l.63.92C230.06,192.74,230,192.84,229.91,192.85Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8,192.62l-1.18.1a.48.48,0,0,1-.36-.2l-.63-.92c-.08-.11,0-.21.07-.22l1.18-.1a.47.47,0,0,1,.37.2l.63.92C233,192.51,232.92,192.61,232.8,192.62Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.7,192.39l-1.18.1a.47.47,0,0,1-.37-.2l-.63-.92c-.08-.11,0-.21.08-.22l1.18-.1a.45.45,0,0,1,.36.2l.63.92C235.85,192.28,235.82,192.38,235.7,192.39Z",
    style: {
      fill: "#a9ff03"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M308,184.18l-1.18.09a.47.47,0,0,1-.36-.19l-.63-.92c-.08-.12-.05-.22.07-.23l1.18-.09a.48.48,0,0,1,.37.19l.63.92C308.15,184.07,308.12,184.17,308,184.18Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.89,184l-1.18.09a.42.42,0,0,1-.36-.19l-.64-.92c-.08-.12,0-.22.08-.23l1.18-.09a.47.47,0,0,1,.36.19l.63.92C311,183.84,311,183.94,310.89,184Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.78,183.72l-1.18.09a.44.44,0,0,1-.36-.19l-.63-.92c-.08-.11-.05-.22.07-.23l1.18-.09a.47.47,0,0,1,.37.19l.63.92C313.94,183.61,313.91,183.71,313.78,183.72Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.68,183.49l-1.18.09a.44.44,0,0,1-.36-.19l-.64-.92c-.08-.11,0-.21.08-.22l1.18-.1a.47.47,0,0,1,.36.19l.64.92C316.83,183.38,316.8,183.48,316.68,183.49Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.58,183.26l-1.19.1a.45.45,0,0,1-.36-.2l-.63-.92c-.08-.11,0-.21.07-.22l1.18-.1a.45.45,0,0,1,.37.2l.63.92C319.73,183.15,319.7,183.25,319.58,183.26Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.47,183l-1.18.1a.47.47,0,0,1-.36-.19l-.64-.92c-.08-.12,0-.22.08-.23l1.18-.09a.44.44,0,0,1,.36.19l.64.92C322.63,182.92,322.59,183,322.47,183Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.37,182.81l-1.19.09a.47.47,0,0,1-.36-.19l-.63-.92c-.08-.12-.05-.22.07-.23l1.19-.09a.44.44,0,0,1,.36.19l.63.92C325.52,182.69,325.49,182.8,325.37,182.81Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.26,182.58l-1.18.09a.47.47,0,0,1-.36-.19l-.64-.92c-.08-.12,0-.22.08-.23l1.18-.09a.44.44,0,0,1,.36.19l.64.92C328.42,182.47,328.38,182.57,328.26,182.58Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.16,182.35l-1.18.09a.47.47,0,0,1-.37-.19l-.63-.92c-.08-.12-.05-.22.08-.23l1.18-.09a.47.47,0,0,1,.36.19l.63.92C331.31,182.24,331.28,182.34,331.16,182.35Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.05,182.12l-1.18.09a.44.44,0,0,1-.36-.19l-.63-.92c-.08-.12-.05-.22.07-.23l1.18-.09a.47.47,0,0,1,.36.19l.64.92C334.21,182,334.17,182.11,334.05,182.12Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.56,186.45l-1.19.09a.44.44,0,0,1-.36-.19l-.63-.92c-.08-.12-.05-.22.07-.23l1.19-.09a.47.47,0,0,1,.36.19l.63.92C309.71,186.34,309.68,186.44,309.56,186.45Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.45,186.22l-1.18.09a.44.44,0,0,1-.36-.19l-.64-.92c-.07-.11,0-.22.08-.23l1.18-.09a.47.47,0,0,1,.36.19l.64.92C312.61,186.11,312.57,186.21,312.45,186.22Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.35,186l-1.18.09a.44.44,0,0,1-.37-.19l-.63-.92c-.08-.11-.05-.21.08-.22l1.18-.1a.47.47,0,0,1,.36.19l.63.92C315.5,185.88,315.47,186,315.35,186Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.24,185.76l-1.18.1a.45.45,0,0,1-.36-.2l-.63-.92c-.08-.11-.05-.21.07-.22l1.18-.1a.44.44,0,0,1,.36.2l.64.92C318.4,185.65,318.36,185.75,318.24,185.76Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.14,185.53l-1.18.1a.48.48,0,0,1-.37-.19l-.63-.92c-.08-.12,0-.22.08-.23l1.18-.09a.44.44,0,0,1,.36.19l.63.92C321.29,185.42,321.26,185.52,321.14,185.53Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,185.31l-1.18.09a.47.47,0,0,1-.36-.19l-.63-.92c-.08-.12-.05-.22.07-.23l1.18-.09a.46.46,0,0,1,.37.19l.63.92C324.19,185.19,324.15,185.3,324,185.31Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.93,185.08l-1.18.09a.48.48,0,0,1-.37-.19l-.63-.92c-.08-.12,0-.22.08-.23l1.18-.09a.44.44,0,0,1,.36.19l.63.92C327.08,185,327.05,185.07,326.93,185.08Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82,184.85l-1.18.09a.47.47,0,0,1-.36-.19l-.63-.92c-.08-.12,0-.22.07-.23l1.18-.09a.48.48,0,0,1,.37.19l.63.92C330,184.74,329.94,184.84,329.82,184.85Z",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.72,184.62l-1.18.09a.46.46,0,0,1-.37-.19l-.63-.92c-.08-.12,0-.22.08-.23l1.18-.09a.47.47,0,0,1,.36.19l.63.92C332.87,184.51,332.84,184.61,332.72,184.62Z",
    style: {
      fill: "#a9ff03"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M140.05,207.19l-59.9,40.87L54.69,210.75l59.94-40.89Zm-75.78,4.43L83,239.07l48.69-33.32L113,178.3Zm24.55,19.84a6.06,6.06,0,0,0-8.41-1.58L71.89,217.4a6,6,0,0,0,1.58-8.4l33.71-23.09a6,6,0,0,0,8.4,1.58L124.11,200a6,6,0,0,0-1.59,8.4Z",
    style: {
      fill: "#a9ff03"
    }
  }), _ref3), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M199.94,166.36,140,207.19l-25.46-37.31L174.43,129Zm-75.78,4.39,18.76,27.46,48.69-33.32-18.76-27.46ZM148.7,190.6a6,6,0,0,0-3.87-2.53,6.05,6.05,0,0,0-4.53.94l-8.53-12.47a6.06,6.06,0,0,0,1.58-8.41L167.06,145a6.06,6.06,0,0,0,8.41,1.58L184,159.1a6.06,6.06,0,0,0-1.58,8.41Z",
    style: {
      fill: "#a9ff03"
    }
  }), _ref4)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M152.94,106.1a5.41,5.41,0,0,1-2.78-5.62v-.12a6.85,6.85,0,0,1,.65-2.2l38.51-80.81c1.55-3.25,5.35-6.1,8.48-6.34L330.85.5l.4,0,.17,0a3.25,3.25,0,0,1,2.43,1,6.28,6.28,0,0,1,2.52,4.92v.27l-1.7.57-.93-.51L295.43,87.11c-1.55,3.25-5.35,6.1-8.47,6.34L156.05,103.8l-2.9,2.4Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref5), _ref6), _ref7, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M150.88,114v0c-.07-.66-.39-5,3.41-7l2.62,1.16-.63,2.61L286.83,100.4c3-.24,7.05,1.89,9,4.77l48,66.84,2.21-1c1.53,5-2.38,6.59-2.38,6.59h0a4,4,0,0,1-1.48.37l-133,10.51c-3,.24-7.05-1.9-9-4.77l-48.24-67.15a5.87,5.87,0,0,1-1-2.47h0Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref8), /*#__PURE__*/React.createElement("path", {
    d: "M343.52,171.5l.35.5,2.22-1c1.53,5-2.39,6.59-2.39,6.59h0a4,4,0,0,1-1.47.37l-1.85.15Z",
    style: {
      fill: "#150035"
    }
  }), _ref9, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M155.64,106.46,288.68,96c3-.24,6.66-3,8.16-6.13L335.36,9c1.5-3.15.28-5.51-2.73-5.27l-133,10.51c-3,.24-6.67,3-8.17,6.13l-38.51,80.81C151.41,104.34,152.63,106.7,155.64,106.46Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref10), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M160.58,98.05,291.69,87.69a3.78,3.78,0,0,0,2.72-2l36.3-76.16c.5-1.05.09-1.84-.91-1.76L198.68,18.09a3.78,3.78,0,0,0-2.72,2l-36.3,76.16C159.16,97.34,159.57,98.13,160.58,98.05Z",
    style: {
      fill: "#fff"
    }
  }), _ref11), _ref12, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M286.85,100.45h.07c2.77-.22,6.37,1.57,8.48,4.08Z",
    style: {
      fill: "#39a1ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.4,106.07l-12.59-6,2.07-.16c2.91-.23,6.66,1.57,8.93,4.27Z",
    style: {
      fill: "#150035"
    }
  })), _ref13), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M210.45,185.81l133-10.51c3-.24,3.84-2.76,1.87-5.63L298,100.75c-2-2.88-6-5-9-4.77l-133,10.51c-3,.23-3.85,2.76-1.87,5.63L201.42,181C203.4,183.91,207.44,186.05,210.45,185.81Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref14), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190,154.52l131.11-10.36c1-.08,1.28-.92.62-1.87l-25.83-37.57a3.78,3.78,0,0,0-3-1.59L161.73,113.49c-1,.08-1.29.92-.63,1.87l25.84,37.57A3.76,3.76,0,0,0,190,154.52Z",
    style: {
      fill: "#5cffe4",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), _ref15), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M294.83,106.71a3.76,3.76,0,0,0-2.75-1.54h-.15L161.08,115.51l0-.06a1.56,1.56,0,0,1-.32-1.52,1.16,1.16,0,0,1,1-.59L292.84,103H293a3.94,3.94,0,0,1,3,1.65l25.84,37.56a1.54,1.54,0,0,1,.28,1.49,1.14,1.14,0,0,1-1,.59l-.4,0Z",
    style: {
      fill: "#a9ff03"
    }
  }), _ref16), _ref17), _ref18, _ref19, _ref20, _ref21, _ref22, /*#__PURE__*/React.createElement("path", {
    d: "M331.94,173.46l-.08-1.07,8-.63a.69.69,0,0,0,.58-1.22L331.12,157l.89-.61,9.33,13.58a1.72,1.72,0,0,1-1.38,2.9Z",
    style: {
      fill: "#150035"
    }
  }), _ref23, _ref24, /*#__PURE__*/React.createElement("rect", {
    x: 328.3,
    y: 150.15,
    width: 1.07,
    height: 5.07,
    transform: "translate(-28.62 213.25) rotate(-34.52)",
    style: {
      fill: "#150035"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.68,
    y: 176.46,
    width: 2.94,
    height: 1.07,
    transform: "translate(32.88 406.1) rotate(-64.52)",
    style: {
      fill: "#150035"
    }
  }), _ref25, _ref26, /*#__PURE__*/React.createElement("path", {
    d: "M151.61,115.77a9.2,9.2,0,0,1,1.34-4.6l.87.63-.43-.32.44.32a8.31,8.31,0,0,0-1.14,4Z",
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.33,121.55a9.87,9.87,0,0,1,1.63-4.43l.86.64a9,9,0,0,0-1.42,3.91Z",
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.36,
    y: 183.67,
    width: 2.42,
    height: 1.07,
    transform: "translate(-50.87 287.81) rotate(-64.52)",
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.33,173.87a1.23,1.23,0,0,1-.46-.4l-28.63-40.4a2.44,2.44,0,0,1-.11-2.25,1.24,1.24,0,0,1,1-.77,1.06,1.06,0,0,1,.94.5l28.63,40.39a2.44,2.44,0,0,1,.11,2.25,1.22,1.22,0,0,1-1,.77A1,1,0,0,1,193.33,173.87Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref27, _ref28, _ref29, _ref30, /*#__PURE__*/React.createElement("rect", {
    x: 190.64,
    y: 16.32,
    width: 1.07,
    height: 2.71,
    transform: "translate(23.75 111.65) rotate(-34.59)",
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.27,
    y: 38.08,
    width: 1.07,
    height: 2.71,
    transform: "translate(9.57 109.61) rotate(-34.59)",
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.61,
    y: 85.08,
    width: 1.07,
    height: 1.35,
    transform: "translate(3.11 181.52) rotate(-34.58)",
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.64,
    y: 94.02,
    width: 1.07,
    height: 2.71,
    transform: "matrix(0.82, -0.57, 0.57, 0.82, -26.89, 104.38)",
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.43,
    y: 98.66,
    width: 1.07,
    height: 2.71,
    transform: "translate(-29.91 103.9) rotate(-34.58)",
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.18,
    y: 103.85,
    width: 1.16,
    height: 1.07,
    transform: "translate(73.14 324.66) rotate(-64.52)",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.5,
    y: 140.56,
    width: 2.76,
    height: 1.07,
    transform: "translate(54.31 368.25) rotate(-64.52)",
    style: {
      fill: "#ffb000"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "text-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.31,42.71a.9.9,0,0,1-.81-.41,1.15,1.15,0,0,1,0-1.15,2.6,2.6,0,0,1,1.9-1.41L243,37.64h.09a.91.91,0,0,1,.81.41,1.17,1.17,0,0,1,0,1.16,2.59,2.59,0,0,1-1.9,1.4l-26.57,2.1Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref31), /*#__PURE__*/React.createElement("g", {
    id: "text-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.53,39.06a.9.9,0,0,1-.81-.41,1.18,1.18,0,0,1,0-1.15,2.6,2.6,0,0,1,1.9-1.41l1.93-.15h.09a.93.93,0,0,1,.82.4,1.2,1.2,0,0,1,0,1.16,2.58,2.58,0,0,1-1.9,1.41l-1.92.15Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref32), /*#__PURE__*/React.createElement("g", {
    id: "text-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.54,40.25a.92.92,0,0,1-.81-.41,1.19,1.19,0,0,1,0-1.16,2.56,2.56,0,0,1,1.9-1.4l10.58-.84h.09a.89.89,0,0,1,.81.41,1.15,1.15,0,0,1,0,1.15,2.6,2.6,0,0,1-1.9,1.41l-10.57.83Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref33), /*#__PURE__*/React.createElement("g", {
    id: "text-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.36,38.52a.92.92,0,0,1-.82-.41,1.2,1.2,0,0,1,0-1.15,2.62,2.62,0,0,1,1.9-1.41l5.87-.46h.09a.93.93,0,0,1,.82.4,1.22,1.22,0,0,1,0,1.16,2.62,2.62,0,0,1-1.9,1.41l-5.87.46Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref34), /*#__PURE__*/React.createElement("g", {
    id: "text-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.62,44a.9.9,0,0,1-.81-.41,1.15,1.15,0,0,1,0-1.15,2.6,2.6,0,0,1,1.9-1.41L285.31,39h.09a.89.89,0,0,1,.81.41,1.15,1.15,0,0,1,0,1.15,2.58,2.58,0,0,1-1.9,1.41L257.72,44Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref35), /*#__PURE__*/React.createElement("g", {
    id: "text-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.05,45.73a.91.91,0,0,1-.81-.41,1.17,1.17,0,0,1,0-1.16,2.56,2.56,0,0,1,1.9-1.4l1.93-.16h.09A.91.91,0,0,1,240,43a1.17,1.17,0,0,1,0,1.16,2.56,2.56,0,0,1-1.9,1.4l-1.93.15Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref36), /*#__PURE__*/React.createElement("g", {
    id: "text-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.39,45.23a.92.92,0,0,1-.81-.41,1.17,1.17,0,0,1,0-1.16,2.56,2.56,0,0,1,1.9-1.4l10.58-.84h.09a.89.89,0,0,1,.81.41A1.15,1.15,0,0,1,255,43a2.6,2.6,0,0,1-1.9,1.41l-10.57.83Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref37), /*#__PURE__*/React.createElement("g", {
    id: "text-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.29,46.58a.94.94,0,0,1-.82-.41,1.2,1.2,0,0,1,0-1.16,2.55,2.55,0,0,1,1.89-1.4l5.87-.47h.1a.93.93,0,0,1,.81.41,1.19,1.19,0,0,1,0,1.16,2.59,2.59,0,0,1-1.9,1.4l-5.87.46Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref38), /*#__PURE__*/React.createElement("g", {
    id: "text-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.2,49.49a.91.91,0,0,1-.81-.41,1.17,1.17,0,0,1,0-1.16,2.56,2.56,0,0,1,1.9-1.4l26.57-2.1h.1a.9.9,0,0,1,.81.4,1.17,1.17,0,0,1,0,1.16,2.6,2.6,0,0,1-1.9,1.41l-26.58,2.1Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref39), /*#__PURE__*/React.createElement("g", {
    id: "text-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.63,51.19a.92.92,0,0,1-.82-.41,1.18,1.18,0,0,1,0-1.15,2.58,2.58,0,0,1,1.9-1.41l1.92-.15h.1a.89.89,0,0,1,.81.41,1.15,1.15,0,0,1,0,1.15,2.6,2.6,0,0,1-1.9,1.41l-1.93.15Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref40), /*#__PURE__*/React.createElement("g", {
    id: "text-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228,50.69a.89.89,0,0,1-.81-.41,1.15,1.15,0,0,1,0-1.15,2.6,2.6,0,0,1,1.9-1.41l10.57-.83h.1a.92.92,0,0,1,.81.41,1.17,1.17,0,0,1,0,1.16,2.56,2.56,0,0,1-1.9,1.4l-10.58.84Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref41), /*#__PURE__*/React.createElement("g", {
    id: "text-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.87,52a.92.92,0,0,1-.82-.41,1.2,1.2,0,0,1,0-1.15,2.62,2.62,0,0,1,1.9-1.41l5.87-.46h.1a.93.93,0,0,1,.81.4,1.19,1.19,0,0,1,0,1.16,2.62,2.62,0,0,1-1.9,1.41L211,52Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref42), /*#__PURE__*/React.createElement("g", {
    id: "text-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.25,58.8a.91.91,0,0,1-.81-.41,1.17,1.17,0,0,1,0-1.16,2.56,2.56,0,0,1,1.9-1.4l26.57-2.1h.1a.93.93,0,0,1,.81.41,1.19,1.19,0,0,1,0,1.16,2.62,2.62,0,0,1-1.9,1.41l-26.58,2.1Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref43), /*#__PURE__*/React.createElement("g", {
    id: "text-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.14,74.63a.92.92,0,0,1-.81-.41,1.17,1.17,0,0,1,0-1.16,2.56,2.56,0,0,1,1.9-1.4l26.58-2.1h.09a.91.91,0,0,1,.81.41,1.17,1.17,0,0,1,0,1.16,2.6,2.6,0,0,1-1.9,1.41l-26.57,2.1Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref44), /*#__PURE__*/React.createElement("g", {
    id: "text-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.52,72.84a.91.91,0,0,1-.81-.41,1.2,1.2,0,0,1,0-1.15,2.59,2.59,0,0,1,1.9-1.41l26.58-2.1h.09a.92.92,0,0,1,.82.41,1.18,1.18,0,0,1,0,1.15,2.58,2.58,0,0,1-1.89,1.41l-26.58,2.1Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref45), /*#__PURE__*/React.createElement("g", {
    id: "text-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.47,55.15a.91.91,0,0,1-.81-.41,1.17,1.17,0,0,1,0-1.16,2.56,2.56,0,0,1,1.9-1.4L261.5,52h.1a.91.91,0,0,1,.81.41,1.17,1.17,0,0,1,0,1.16,2.59,2.59,0,0,1-1.9,1.4l-1.93.15Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref46), /*#__PURE__*/React.createElement("g", {
    id: "text-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.48,56.33a.89.89,0,0,1-.81-.41,1.15,1.15,0,0,1,0-1.15,2.58,2.58,0,0,1,1.9-1.41l10.57-.83h.1a.92.92,0,0,1,.81.41,1.19,1.19,0,0,1,0,1.16,2.56,2.56,0,0,1-1.9,1.4l-10.58.84Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref47), /*#__PURE__*/React.createElement("g", {
    id: "text-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.29,54.61a.91.91,0,0,1-.81-.41,1.17,1.17,0,0,1,0-1.16,2.56,2.56,0,0,1,1.9-1.4l5.87-.47h.09a.91.91,0,0,1,.81.41,1.17,1.17,0,0,1,0,1.16,2.59,2.59,0,0,1-1.9,1.4l-5.86.47Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref48), /*#__PURE__*/React.createElement("g", {
    id: "text-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.56,60.11a.91.91,0,0,1-.81-.41,1.17,1.17,0,0,1,0-1.16,2.56,2.56,0,0,1,1.9-1.4L282.24,55h.1a.93.93,0,0,1,.81.41,1.19,1.19,0,0,1,0,1.16,2.62,2.62,0,0,1-1.9,1.41l-26.58,2.1Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref49), /*#__PURE__*/React.createElement("g", {
    id: "text-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233,61.81a.91.91,0,0,1-.81-.41,1.2,1.2,0,0,1,0-1.15,2.62,2.62,0,0,1,1.9-1.41l1.93-.15h.1a.93.93,0,0,1,.81.4,1.19,1.19,0,0,1,0,1.16,2.62,2.62,0,0,1-1.9,1.41l-1.93.15Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref50), /*#__PURE__*/React.createElement("g", {
    id: "text-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.5,70.49a.92.92,0,0,1-.82-.41,1.2,1.2,0,0,1,0-1.15,2.62,2.62,0,0,1,1.9-1.41l1.93-.15h.1a.91.91,0,0,1,.81.41,1.17,1.17,0,0,1,0,1.15,2.6,2.6,0,0,1-1.9,1.41l-1.93.15Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref51), /*#__PURE__*/React.createElement("g", {
    id: "text-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.33,61.31a.92.92,0,0,1-.82-.41,1.18,1.18,0,0,1,0-1.15,2.58,2.58,0,0,1,1.89-1.41L251,57.5h.1a.93.93,0,0,1,.81.41,1.19,1.19,0,0,1,0,1.16,2.58,2.58,0,0,1-1.9,1.4l-10.58.84Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref52), /*#__PURE__*/React.createElement("g", {
    id: "text-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.22,62.66a.91.91,0,0,1-.81-.41,1.17,1.17,0,0,1,0-1.15,2.6,2.6,0,0,1,1.9-1.41l5.87-.46h.09a.93.93,0,0,1,.82.4,1.22,1.22,0,0,1,0,1.16,2.62,2.62,0,0,1-1.9,1.41l-5.87.46Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref53), /*#__PURE__*/React.createElement("g", {
    id: "text-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.14,66.57a.93.93,0,0,1-.82-.4,1.22,1.22,0,0,1,0-1.16,2.62,2.62,0,0,1,1.9-1.41l26.58-2.1h.1a.93.93,0,0,1,.81.41,1.22,1.22,0,0,1,0,1.16,2.6,2.6,0,0,1-1.9,1.4l-26.58,2.1Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref54), /*#__PURE__*/React.createElement("g", {
    id: "text-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.56,67.28a.93.93,0,0,1-.81-.41,1.19,1.19,0,0,1,0-1.16,2.58,2.58,0,0,1,1.9-1.4l1.93-.16h.1a.93.93,0,0,1,.81.41,1.22,1.22,0,0,1,0,1.16,2.58,2.58,0,0,1-1.9,1.4l-1.93.16Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref55), /*#__PURE__*/React.createElement("g", {
    id: "text-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.91,67.78a.94.94,0,0,1-.82-.41,1.22,1.22,0,0,1,0-1.16,2.58,2.58,0,0,1,1.9-1.4L236.59,64h.1a.91.91,0,0,1,.81.41,1.2,1.2,0,0,1,0,1.15,2.62,2.62,0,0,1-1.9,1.41L225,67.77Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref56), /*#__PURE__*/React.createElement("g", {
    id: "text-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.8,68.13a.91.91,0,0,1-.81-.41,1.17,1.17,0,0,1,0-1.16,2.56,2.56,0,0,1,1.9-1.4l5.87-.47h.09a.94.94,0,0,1,.82.41,1.2,1.2,0,0,1,0,1.16,2.56,2.56,0,0,1-1.9,1.4l-5.86.47Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref57))), /*#__PURE__*/React.createElement("rect", {
    x: 164.99,
    y: 130.85,
    width: 1.5,
    height: 3.23,
    transform: "translate(-36.1 67.06) rotate(-20.68)",
    style: {
      fill: "#5cffe4"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "326.68 214.83 356.23 248.06 356.23 248.06 322.02 218.56 326.68 214.83",
    style: {
      fill: "none"
    }
  }), _ref58), _ref59, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M234.15,171.46l.68,4.47a8.22,8.22,0,0,0,1.72,3.91l3.06,3.79,5.79-8.07-4.68-4.28Z",
    style: {
      fill: "#5cffe4",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), _ref60), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "326.81 216.3 354.79 248.06 342.8 248.06 320.43 219.93 326.81 216.3",
    style: {
      fill: "#a9ff03"
    }
  }), _ref61), /*#__PURE__*/React.createElement("path", {
    d: "M247.68,234.72a8.9,8.9,0,0,1-2-1.25c-2.63-2.23-4.3-6.7-.4-11.95,5.21-7,6.67-16.38,6.68-16.47l2.45.37c-.06.4-1.55,10.07-7.14,17.58-2.45,3.28-2.44,6.49,0,8.58,2.73,2.32,7.74,2.46,11.41-1.32l1.78,1.73A11.19,11.19,0,0,1,247.68,234.72Z",
    style: {
      fill: "#5cffe4",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "252.26 215.07 255.48 248.06 280.86 248.06 265.13 214.78 259.57 210.37 252.26 215.07",
    style: {
      fill: "#a9ff03"
    }
  }), _ref62), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "275.07 239.43 278.6 248.06 343.92 248.06 318.97 213.3 309.14 201.05 282.91 202.15 272.61 223.37 271.91 231.82 275.07 239.43",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.6,248.06l-4-8.43-3.21-7.73.75-8.77,10.44-21.51,26.83-1.11,10,12.45L345,248.06Zm66.41,0-26.46-34.44-9.65-12-25.65,1.07-10.12,20.84-.67,8.22,6.14,16.33Z",
    style: {
      fill: "#a9ff03"
    }
  })), _ref63, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M241.7,184.86l3.85,19a2.34,2.34,0,0,0,.24.67l6.7,12.52A2.46,2.46,0,0,0,256,218h0a2.48,2.48,0,0,1,2.5-.06l6.91,3.87a2.49,2.49,0,0,0,2.24.08c2-.93,5.93-2.93,6.53-4.58.81-2.24-.44-14.13-1.49-15.89-.95-1.61-10.33-9.6-12-11a2.12,2.12,0,0,0-.57-.36l-8.81-4a2.43,2.43,0,0,0-.92-.22l-9-.38Z",
    style: {
      fill: "#5cffe4",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), _ref64), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M212.72,128.38l3.19-2.31,6.85-.25h3.79L228,127a2.2,2.2,0,0,1-.17,3.5h0l13.51,8.51,11.22-2.92a25.54,25.54,0,0,0,.29-3.31L248.65,129l-11.47-6.24-6-3.79-9.38.85-8,3-2.94,2.72s-2,2.4-.18,3.18A2,2,0,0,0,212.72,128.38Z",
    style: {
      fill: "#5cffe4",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), _ref65), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M243.27,123.52l1.73-.15,2.3.87,6.43,6.89h0l.33.86a1,1,0,0,1-1,1.3l-3-.32h0l-9.2-8.15h0l2.42-1.29Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref66), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M263.1,142.64a30,30,0,0,1,3.55-9.27,39.4,39.4,0,0,1,3.13-4.21c1.55-1.82,2.4-2.83,4.57-1.85l1.72.46c1.26.57,1,2,.39,3.21A35.45,35.45,0,0,0,273.87,145a45.94,45.94,0,0,1-1.49,13.35l-11-14.68Z",
    style: {
      fill: "#5cffe4",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.58,159.55l-11.93-16,2-1.24a30.18,30.18,0,0,1,3.58-9.23,39.44,39.44,0,0,1,3.17-4.27c1.56-1.82,2.66-3.12,5.16-2l1.77.47a1.89,1.89,0,0,1,1.07,1.11,3.73,3.73,0,0,1-.42,2.81A34.72,34.72,0,0,0,274.41,145a45.83,45.83,0,0,1-1.52,13.52ZM262.2,143.84l9.95,13.33A48.91,48.91,0,0,0,273.34,145,35.79,35.79,0,0,1,276,130.75a2.76,2.76,0,0,0,.38-2,.88.88,0,0,0-.47-.48l-1.76-.48c-1.79-.81-2.37-.13-3.91,1.68a36.06,36.06,0,0,0-3.11,4.18,29.58,29.58,0,0,0-3.48,9.08l0,.23Z",
    style: {
      fill: "#150035"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M267.79,134.38l.21,2.93a.92.92,0,0,0,.54.78l3.52,1.61a.92.92,0,0,0,1.14-.3l1.57-2.16a1,1,0,0,1,1-.36l.08,0a.94.94,0,0,1,.71,1l-1.08,7.82a.93.93,0,0,1-1.1.79h0a1,1,0,0,1-.67-.52l-1.13-2.37a.91.91,0,0,0-.56-.49l-4.35-1.41a.93.93,0,0,0-1,.32l-1.29,1.64a.93.93,0,0,1-1.45,0L262,141.54a.92.92,0,0,1-.14-1l3.06-6.93a.93.93,0,0,1,1.21-.48l1.06.44A.92.92,0,0,1,267.79,134.38Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref67), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M273.07,136.13h0c1.19,0,2.61-1.49,3-2.61l.41-1.21.46-3.38a3.41,3.41,0,0,0-3.12-3.85h0a3.31,3.31,0,0,0-3.42,2.31L269,131.77a2.76,2.76,0,0,0,.29,2.31h0A7.12,7.12,0,0,0,273.07,136.13Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref68), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M265.78,145l.56-.6a3.62,3.62,0,0,1,4-.92h0a3.6,3.6,0,0,1,2.07,2.1l1,2.74-.38,6.45-8-5.89Z",
    style: {
      fill: "#5cffe4",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), _ref69)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M239.45,174.47v8.36a2.15,2.15,0,0,0,.16.8h0A47.76,47.76,0,0,0,257,204.82l.84.56L270.57,194s-6.38-13.19-7-14.09-11.37-8.72-11.37-8.72l-8.18-4.72Z",
    style: {
      fill: "#a9ff03",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), _ref70), /*#__PURE__*/React.createElement("g", null, _ref71, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M254.36,191.73l-.21,8.84a2.2,2.2,0,0,0,1.94,3.07l2.69.1,7.59,11.36-6.11,3.45h0l5.31,17.63a5.64,5.64,0,0,0,6.2,4l7.82-1.1-1.23-5.31,8.9-.87h0c0-.15-.41-7.69-7.67-7.63l1.72-11.55a73.81,73.81,0,0,0,23.41-13.36l15,9.26,2.57,3.55,7.13,9.36a.21.21,0,0,0,.35,0l.8-1.39a3.76,3.76,0,0,0-.16-4l-6.79-9.88,1.69-1.56h0l-3.44-4a1.74,1.74,0,0,0-2.55-.09l-.58.59-12.82-11.66-.81-3.95a3.44,3.44,0,0,0-2.87-2.7l-3.74-.55-24.34,12.73Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref72), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M254.17,207.58a3.11,3.11,0,0,1-1.26-.29,2.3,2.3,0,0,1-.87-.71,3.74,3.74,0,0,1-.41-2.9l.08-2,1.33.07-.11,2.11a2.42,2.42,0,0,0,.18,1.91,1.36,1.36,0,0,0,1.11.46l2.31.09,1.39-2.26,1.13.69-1.8,2.93Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref73), /*#__PURE__*/React.createElement("rect", {
    x: 302.49,
    y: 201.85,
    width: 3.32,
    height: 0.83,
    transform: "matrix(0.5, -0.86, 0.86, 0.5, -23.94, 362.8)",
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.74,
    y: 210.68,
    width: 3.21,
    height: 0.83,
    transform: "translate(-25.84 376.76) rotate(-59.25)",
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.65,
    y: 236.97,
    width: 3.78,
    height: 0.82,
    transform: "translate(-73.24 347.99) rotate(-60.03)",
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.69,
    y: 241.45,
    width: 3.78,
    height: 0.82,
    transform: "translate(-74.61 354.6) rotate(-60.03)",
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 259.33,
    y: 205.64,
    width: 1.33,
    height: 11.51,
    transform: "translate(-72.71 171.49) rotate(-32.27)",
    style: {
      fill: "#5cffe4"
    }
  }), _ref74), /*#__PURE__*/React.createElement("polygon", {
    points: "273.58 243.33 273.47 242.51 276.64 242.06 277.72 241.46 279.13 238.99 279.85 239.4 278.32 242.06 276.83 242.87 273.58 243.33",
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.47,
    y: 236.16,
    width: 3.25,
    height: 0.83,
    transform: "translate(-22.07 29.03) rotate(-5.69)",
    style: {
      fill: "#5cffe4"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M262.15,184.23l-6.67-18-10.32-7.73-5.35-5,14.29-13.45,1.72-.92-1.66-5.6-25.42,8.92a31.49,31.49,0,0,0,3.83-3.28c.92-1.22,2.12-5.61,2.12-5.61l-4-2.81-8.11-.67-6.8,2.42-1.71,6.58-4.14,2.63-3.43,8.4v11.05l.53-.11a1.75,1.75,0,0,0,3.06-1.68.75.75,0,0,1,0-.16l-.18-3.9,4.77-6.77,2.11-1.13s2.2,1.65,3.72,1.62h0a13.48,13.48,0,0,1,4.61,9.76l.09,3.19,4.77,7.63s11.28,4,16.37,11.08,8.24,13.2,13.29,10.63A5.06,5.06,0,0,0,262.15,184.23Z",
    style: {
      fill: "#5cffe4",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), _ref75), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M252.66,171.56l-.6,14.34A43.64,43.64,0,0,0,256.7,196a8.49,8.49,0,0,0,3.58,3.16l6.42,3A27,27,0,0,0,291.82,201a3.37,3.37,0,0,0,.32-.19,15.77,15.77,0,0,0,7.66-15.37h0l-13.93-16.15-7.39-5.36-20.21,1.26Z",
    style: {
      fill: "#a9ff03",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), _ref76), /*#__PURE__*/React.createElement("g", null, _ref77, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M240.13,142.36l-9.06,9.39.59,12.56,8.88,3.53,3.93-.76,17.28,9.16,17.08-8.59,1.75-4.55-16.31-22.41L256,137.37S245.73,139.23,240.13,142.36Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref78), /*#__PURE__*/React.createElement("rect", {
    x: 229.49,
    y: 165.15,
    width: 2.89,
    height: 0.82,
    transform: "translate(-27.85 282.93) rotate(-60.03)",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.48,
    y: 168.85,
    width: 2.49,
    height: 0.82,
    transform: "translate(-26.65 292.4) rotate(-60.03)",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.42,
    y: 168.24,
    width: 2.49,
    height: 0.82,
    transform: "translate(-24.15 295.51) rotate(-60.03)",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.58,
    y: 177.07,
    width: 2.89,
    height: 0.82,
    transform: "translate(-23.13 314.94) rotate(-60.03)",
    style: {
      fill: "#5cffe4"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M210.43,126.65l.55-2.33h0l5.73-3.39a.62.62,0,0,1,.91.32l1.51,4.09a.65.65,0,0,1-.59.87l-5.1.17h0l-3,.29Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref79), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M221,119.14l-1,1.78h0l.5,4.88h6.06l1.28-4h0l3.58-2.1a.74.74,0,0,0-.32-1.38L223,117.8h0L221,119.14Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref80), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M236,120.75l-4.88,2h0l-1.29,3.38h0l5.84,7.53h0l3.33,1.92h0l1.38-3.21h0l7.31-1.73a.52.52,0,0,0,.23-.88l-9.31-8.5A2.52,2.52,0,0,0,236,120.75Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref81), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M212.26,135.1l3.69-4.51a.34.34,0,0,1,.48,0l.84.82a.33.33,0,0,1,.1.3l-1.41,7a.31.31,0,0,1-.26.25l-2.74.53a.32.32,0,0,1-.38-.28l-.4-3.85A.37.37,0,0,1,212.26,135.1Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref82), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M221.72,129.34l-1.65,1.2a.3.3,0,0,0-.12.17l-2.08,7.5a.32.32,0,0,0,.3.41l5.15.14a.35.35,0,0,0,.31-.2l2.64-6.33a.21.21,0,0,1,.06-.1l2.09-2.19a.33.33,0,0,0-.23-.55l-6.28-.12A.32.32,0,0,0,221.72,129.34Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref83), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M232.73,131l-3.59,1.72a.29.29,0,0,0-.15.16l-2.34,5.1a.33.33,0,0,0,.11.41l6,3.88a.33.33,0,0,0,.39,0l2-1.62a.21.21,0,0,1,.1-.06l7.07-2.24a.33.33,0,0,0,.22-.35l-.24-1.95a.3.3,0,0,0-.17-.25L233,131A.33.33,0,0,0,232.73,131Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref84), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M204.2,150.59l.33,8.95a.94.94,0,0,0,.13.44l1.5,2.39a.86.86,0,0,0,.69.41l.58,0a.89.89,0,0,0,.93-1l-.28-2.49a.91.91,0,0,1,.11-.54l3-5.26a2,2,0,0,0-.63-2.6l-2.89-1.86a2.22,2.22,0,0,0-2.9.43l-.39.47A.88.88,0,0,0,204.2,150.59Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref85), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M208.67,143.86l1-3a1.23,1.23,0,0,1,.43-.58l4.32-3.12a1.17,1.17,0,0,1,.85-.22l1.91.25a1.2,1.2,0,0,1,1,1.08l.5,5.53a1.13,1.13,0,0,1-.05.48l-.77,2.32a1.14,1.14,0,0,1-.63.71l-3.73,1.7a1.19,1.19,0,0,1-1.39-.29L208.9,145A1.18,1.18,0,0,1,208.67,143.86Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref86), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M221.65,138.25l1.19-1.51a1.8,1.8,0,0,1,1.52-.69l2.72.14a1.69,1.69,0,0,1,.81.24l4.29,2.47a1.82,1.82,0,0,1,.76.84l1,2.26a1.79,1.79,0,0,1-.42,2.06l-6.16,5.74a1.8,1.8,0,0,1-2,.34l-3.56-1.55a1.79,1.79,0,0,1-.78-.66l-.59-.88a1.87,1.87,0,0,1-.28-1.3l1.1-6.67A1.88,1.88,0,0,1,221.65,138.25Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref87), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "242.55 133.79 248.1 132.5 248.34 133.55 242.79 134.84 242.55 133.79",
    style: {
      fill: "#a9ff03"
    }
  }), _ref88), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 235.91,
    y: 140.77,
    width: 4.64,
    height: 1.08,
    transform: "translate(-28.67 67.25) rotate(-15.17)",
    style: {
      fill: "#a9ff03"
    }
  }), _ref89), _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, /*#__PURE__*/React.createElement("path", {
    d: "M244.24,205.38c-5.64-2.69-7.08-6.22-7.28-8.77a10,10,0,0,1,4.21-8.59c2.21-1.36.75-4.76.69-4.9l2.26-1c.85,1.9,1.59,6-1.66,8a7.4,7.4,0,0,0-3,6.29c.22,2.88,2.54,5.33,6.74,7.11l2.66.9-.8,2.35-2.78-.95Z",
    style: {
      fill: "#5cffe4",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,206.48l.73-2.37s1,.31,2.53.74l-.69,2.38Z",
    style: {
      fill: "#a9ff03",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M243.11,184.51a1.81,1.81,0,0,1-1.76-1.35,1.82,1.82,0,0,1,1.76-2.29,1.82,1.82,0,1,1,0,3.64Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref103), _ref104), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M261.94,243.71a1.57,1.57,0,1,1-1-2A1.57,1.57,0,0,1,261.94,243.71Z",
    style: {
      fill: "#5cffe4",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px"
    }
  }), _ref105), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 229.95,
    y: 128.03,
    width: 1.08,
    height: 3.52,
    transform: "translate(48.51 321.76) rotate(-75.91)",
    style: {
      fill: "#a9ff03"
    }
  }), _ref106), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 251.83,
    y: 135.34,
    width: 4.64,
    height: 1.08,
    transform: "translate(-26.68 71.17) rotate(-15.15)",
    style: {
      fill: "#a9ff03"
    }
  }), _ref107), _ref108), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M250.15,123.26c-2.24-2.7-6.63-2.74-6.82-2.74h-.12l0-.12v-1h.13c.57,0,5.17.09,7.68,3.13l2.57,3.1-.83.69Z",
    style: {
      fill: "#a9ff03"
    }
  }), _ref109), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 254.64,
    y: 126.88,
    width: 1.08,
    height: 4.06,
    transform: "translate(-28.12 167.34) rotate(-34.53)",
    style: {
      fill: "#a9ff03"
    }
  }), _ref110), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M207.19,132a7.35,7.35,0,0,1-1.12-2.48l0-.12,1.05-.25,0,.12a6.07,6.07,0,0,0,1,2.11l.07.11-.89.61Z",
    style: {
      fill: "#a9ff03"
    }
  }), _ref111), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M205.9,128.42a7.69,7.69,0,0,1,1.6-5l.08-.09.82.68-.08.1a6.78,6.78,0,0,0-1.34,4.26v.13l-1.08.06Z",
    style: {
      fill: "#a9ff03"
    }
  }), _ref112), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M268.12,125.21l.05-.12c.06-.14,1.58-3.45,5.07-3.55h.12l0,1.08h-.12c-2.82.07-4.11,2.88-4.12,2.91l0,.11Z",
    style: {
      fill: "#a9ff03"
    }
  }), _ref113), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M288.74,121.42c-.15,0-3.7-.8-4.53-4.2l0-.13,1.05-.25,0,.12c.67,2.75,3.68,3.4,3.71,3.41l.13,0-.22,1.06Z",
    style: {
      fill: "#a9ff03"
    }
  }), _ref114))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M293,143.34l-.68-10.8,4.26-6.55,6-2.69-10.11-3.66a3.57,3.57,0,0,1-1.86-1.5l-1.22-2,1-2,12.72,1.14,7.26,1.07,8.51-3.23,4.75-1.32,5.58,2.66.64,1.57,4.12.7,2.33,1.11,5.87,8.92-21.68,11.06-9.8-2.23-5.91-3.43a2.4,2.4,0,0,0-2.48,0l-4.94,3.07s-1.55,9.17-1.56,9.18C294.87,145.1,293,143.34,293,143.34Z",
    style: {
      fill: "#5cffe4",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.23,144.86a7,7,0,0,1-1.59-1.13l-.15-.15-.71-11.19,4.45-6.82,4.9-2.21-8.87-3.21a4.18,4.18,0,0,1-2.12-1.72l-1.38-2.2,1.26-2.64,13.08,1.18,7.16,1,8.38-3.18,5-1.39,5.94,2.84.61,1.48,4,.7,2.46,1.17L342.9,127,320.51,138.4l-10.07-2.28-.07-.05-5.91-3.43a1.86,1.86,0,0,0-1.93,0l-4.73,2.94c-1.55,9.15-1.55,9.15-1.73,9.28A1.79,1.79,0,0,1,294.23,144.86Zm-.7-1.77a3.79,3.79,0,0,0,1.75,1l1.5-8.88,0-.24,5.14-3.19a2.94,2.94,0,0,1,3,0l5.84,3.4,9.53,2.16,21-10.7-5.46-8.29-2.12-1-4.35-.75-.67-1.64-5.21-2.48L319,113.66l-8.6,3.26-7.4-1.08-12.31-1.11-.69,1.43,1.07,1.7a3.12,3.12,0,0,0,1.58,1.28L304,123.25l-7,3.16-4.09,6.27Z",
    style: {
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "283.71 140.06 283.17 142.63 286.36 146.5 297.68 152.96 309.09 158.7 311.75 151.01 310.89 149.73 298.55 145.89 285.09 139.56 283.71 140.06",
    style: {
      fill: "#5cffe4",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), _ref115), _ref116, _ref117, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M329.19,168l6.49,8.88S347,185.8,351.13,185l-5.62-11.43Z",
    style: {
      fill: "#a9ff03",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,184.21a67.29,67.29,0,0,1-10.69-6.93l-.1-.1-7.5-10.26,18.14,6.2,6,12.25-.68.14C349.94,185.76,348.06,185.18,346,184.21Zm-10-7.73c2.93,2.3,10.64,7.76,14.22,8L345.13,174l-14.5-5Z",
    style: {
      fill: "#020202"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M363.89,198.55s23.85,29.12,28.52,49.51h6.1v-22.8l-27.85-34.93-8.4,0Z",
    style: {
      fill: "#a9ff03"
    }
  }), _ref118), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M309.09,158.7a31.63,31.63,0,0,0,9.17,6.66c4.91,2.29,18,5,24.55,9.41,3.83,2.6,5.44,7.81,6.12,11.65a14.54,14.54,0,0,0,15,12.13l.93-.07,6-5.64S363,183.51,363,182.49s-5.13-13.55-5.13-13.55L337,159,324,153.42l-6.49-5.57,1.45-12-12.34-6.76-.4,3.93s6,3.47,6.54,7.84a13.27,13.27,0,0,1-2.25,8.24Z",
    style: {
      fill: "#5cffe4",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), _ref119), /*#__PURE__*/React.createElement("polygon", {
    points: "383.09 211 398.51 226.95 398.53 171.63 375.7 189.09 377.46 198.97 383.09 211",
    style: {
      fill: "#a9ff03"
    }
  }), _ref120, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M391.21,225.66a1.57,1.57,0,1,1-1.84-1.25A1.58,1.58,0,0,1,391.21,225.66Z",
    style: {
      fill: "#5cffe4",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), _ref121), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M393.58,229.69a1.57,1.57,0,1,1-1.84-1.25A1.57,1.57,0,0,1,393.58,229.69Z",
    style: {
      fill: "#5cffe4",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), _ref122), _ref123, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M398.53,175h0l0-7.22-2.05-1c-.21-.58-.42-1.2-.63-1.85a3.74,3.74,0,0,0-2-2.3h0c-2.66-1.26-8.59-2.74-10.6-.61l-5.93,15.75L362.79,175l-5.93,1.83-.11,1.39a6.89,6.89,0,0,0,3.91,6.74h0l-.66,3.52h0a7.45,7.45,0,0,0,6.32,2.73,15.61,15.61,0,0,1,4.84.48l3.4,8.45-2.1,3a1.61,1.61,0,0,0,.27,2.15l12.6,10.84,9.69-.9h0a6.87,6.87,0,0,0-5.32-6.89l-2.14-.5-7-9.82.38-2.64A21.66,21.66,0,0,1,386,184.21c.87-1,4-3.59,5-4.52l1.29-1.18C394.48,176.54,395.6,175,398.53,175Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref124), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M339.77,167.83l1.23,1.69a1.9,1.9,0,0,0,2.34.6,9.21,9.21,0,0,1,8.15.2c5,2.54,5.37,6.48,5.37,6.48l7.78,3.5s13.56,5.35,21.62-2.4-3-15.9-3-15.9l-19.91-11.32-1.4-2.9a4.24,4.24,0,0,0-4.22-2.37h0l-11,8.18-5.09,5.81Z",
    style: {
      fill: "#a9ff03",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), _ref125), _ref126, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M317.85,134.66l-1.93,9.07,8.92,15.57s6.33,7.59,14.16,6.75l5.48-1.84a.4.4,0,0,0,.26-.3l.77-3.91,10.88-10.36,2.89-.26a.4.4,0,0,0,.32-.59l-1.86-3.38s-9.62-6.57-12.71-17.19a12.68,12.68,0,0,0-5.89-5.4l-5.94-.08-12,7.23A7.25,7.25,0,0,0,317.85,134.66Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref127), _ref128, _ref129, _ref130, _ref131, _ref132, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M368.81,194.55a46.37,46.37,0,0,0-4.86-.35,9,9,0,0,1-3.46-.84,7.35,7.35,0,0,1-2.72-2.13l-.1-.15.59-3.35c-5.73-2.54-3.71-8.58-3.69-8.64l1.05-1.49.87.63-.94,1.3c-.16.52-1.59,5.39,3.51,7.37l.42.16-.69,3.71a7.2,7.2,0,0,0,5.2,2.35,43,43,0,0,1,5,.37l.12,0-.2,1Z",
    style: {
      fill: "#5cffe4"
    }
  }), _ref133), /*#__PURE__*/React.createElement("path", {
    d: "M390.21,218.39l.08-.82s2.72.25,3.46-1.28l.74.36C393.5,218.69,390.34,218.41,390.21,218.39Z",
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.05,
    y: 144.82,
    width: 3.04,
    height: 0.83,
    transform: "translate(86.03 405.98) rotate(-73.36)",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.77,
    y: 161.13,
    width: 3.04,
    height: 0.83,
    transform: "translate(77.41 427) rotate(-73.37)",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.54,
    y: 166.6,
    width: 3.04,
    height: 0.83,
    transform: "translate(78.36 439.25) rotate(-73.36)",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.75,
    y: 184.52,
    width: 3.04,
    height: 0.83,
    transform: "translate(77.76 474.27) rotate(-73.36)",
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.34,
    y: 216.69,
    width: 3.04,
    height: 0.83,
    transform: "translate(65.92 522.71) rotate(-73.36)",
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.65,
    y: 207.18,
    width: 3.04,
    height: 0.83,
    transform: "translate(67.39 505.67) rotate(-73.36)",
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.68,
    y: 150.5,
    width: 3.04,
    height: 0.83,
    transform: "translate(109.66 449.04) rotate(-73.37)",
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.71,
    y: 192.12,
    width: 3.04,
    height: 0.83,
    transform: "translate(76.88 488.29) rotate(-73.36)",
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.43,
    y: 166.26,
    width: 0.83,
    height: 4.77,
    transform: "translate(78.4 440.11) rotate(-74.64)",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.4,196.5a10.28,10.28,0,0,1-3.71-2.9,7.5,7.5,0,0,1-1.38-6.46c1.42-6.23-.57-8.85-.59-8.88l1.91-1.57c.12.13,2.81,3.45,1.1,11a5,5,0,0,0,.92,4.39,8.33,8.33,0,0,0,5.58,2.94,5.11,5.11,0,0,0,5-4.79l2.46.21a7.61,7.61,0,0,1-7.51,7.06A9.69,9.69,0,0,1,344.4,196.5Z",
    style: {
      fill: "#5cffe4",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.54,193.91l-2.2-1.13a10.35,10.35,0,0,0,1.05-3.71l2.47.06A12.76,12.76,0,0,1,354.54,193.91Z",
    style: {
      fill: "#a9ff03",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M341.23,177.19a1.57,1.57,0,1,1-1.84-1.25A1.57,1.57,0,0,1,341.23,177.19Z",
    style: {
      fill: "#5cffe4",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), _ref134), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,222.75a11.19,11.19,0,0,1-2.18-1.37A14.22,14.22,0,0,1,361.84,209a16.16,16.16,0,0,0-3.29-11.92l1.81-1.68c.2.21,4.77,5.25,3.94,13.84a11.72,11.72,0,0,0,4,10.24,8,8,0,0,0,7.67,1.38,6.48,6.48,0,0,0,2.07-1.12l1.57,1.92a8.82,8.82,0,0,1-2.88,1.55A10.33,10.33,0,0,1,368.89,222.75Z",
    style: {
      fill: "#5cffe4",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M311.27,151.88l-.7,4.57a.54.54,0,0,1-.11.26l-.85,1.14a.78.78,0,0,0-.08.39,3.74,3.74,0,0,0,2.31,3.54,14.31,14.31,0,0,0,2.47.82c.56.13,1.19-2.09,1.07-2.58l-1.27-4.81v0l-.88-4.39a1,1,0,0,0-.86-.72h0a.68.68,0,0,0-.78.48l-.3,1.31Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref135), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M282.87,138.93l-.5.67a1.54,1.54,0,0,0,.05,1.75l2.24,3.72a3,3,0,0,0,.89.92l3.58,2.4c1.18.79,2.66.71,3.19-.17l.9-1.52a1.56,1.56,0,0,1,.23-.28L294,146c.81-.74.39-2.13-.87-2.91l-6.71-4.16a3.26,3.26,0,0,0-1.18-.44l-.49-.09A1.87,1.87,0,0,0,282.87,138.93Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref136), _ref137), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M296.87,145.37l-.83,1a1.35,1.35,0,0,0-.15.26l-1.22,3.1a1.33,1.33,0,0,0-.06.56l.09.81a1.82,1.82,0,0,0,1.09,1.3l9.66,5.33a1.63,1.63,0,0,0,1.95-.27l1-1.07a1,1,0,0,0,.22-.59l.28-5a1.28,1.28,0,0,0-.17-.72l-.78-1.39a2,2,0,0,0-1.12-.91l-8.23-2.8A1.55,1.55,0,0,0,296.87,145.37Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref138), _ref139), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M294.32,127.11l-3,6.36a.83.83,0,0,0,0,.72l.49,1a.85.85,0,0,0,.57.46l4.38,1a.84.84,0,0,0,1-.71l.23-1.72a.75.75,0,0,1,.17-.4l1.12-1.46a.84.84,0,0,0,.08-.9l-1.72-3.34a.81.81,0,0,1,0-.68l.59-1.62a.86.86,0,0,0-.48-1.08l-.59-.23a.85.85,0,0,0-1,.25l-1.73,2.11A1,1,0,0,0,294.32,127.11Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref140), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M291.49,139.16l.8,2.94a.84.84,0,0,0,.38.49l2.83,1.75.41-.87a1,1,0,0,0,.08-.29l.35-3.81a.85.85,0,0,0-.75-.92l-3.19-.35A.84.84,0,0,0,291.49,139.16Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref141), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M301.49,122.66l-1.38,2.9a1.21,1.21,0,0,0-.09.75l.57,2.73a1.18,1.18,0,0,0,1,.93l5.15.9a.67.67,0,0,1,.19,0l5.79,2.07a1.19,1.19,0,0,0,1.48-.6l.8-1.68a1.21,1.21,0,0,1,.4-.47l5.15-3.55a1.19,1.19,0,0,0-.24-2.09l-8.45-3.3a1.2,1.2,0,0,0-.53-.08l-8.82.76A1.23,1.23,0,0,0,301.49,122.66Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref142), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M289,114.57l-.55.64a.87.87,0,0,0-.15.25h0a1.9,1.9,0,0,0,1.37,2.51c1.65.37,3.93.88,5,1.14a.89.89,0,0,0,1-.48l.93-2a.85.85,0,0,1,.59-.47l2.36-.57a.89.89,0,0,0,.59-.48h0a.88.88,0,0,0-.7-1.26l-6.92-.74A4.1,4.1,0,0,0,289,114.57Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref143), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M299.94,118.16l.64-1.34a1.81,1.81,0,0,1,.71-.81l2.54-1.62a2,2,0,0,1,1.29-.29l7.76,1a2.06,2.06,0,0,1,1.12.53l.25.25a2,2,0,0,1,.06,2.75l-1,1.06a2,2,0,0,1-1.27.6l-3.65.3h-.13l-2.45,0h-.13l-3.82.33a2,2,0,0,1-2.12-1.84h0A1.93,1.93,0,0,1,299.94,118.16Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref144), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M315.81,119l1-1.09a1.5,1.5,0,0,1,.82-.46l1.28-.25a1.56,1.56,0,0,1,.8.07l6.49,2.42a1.45,1.45,0,0,1,.68.52h0a1.48,1.48,0,0,1-.49,2.17L323,124.22a1.47,1.47,0,0,1-1.55-.09l-2.35-1.63a2.69,2.69,0,0,0-.29-.16l-2.41-1A1.48,1.48,0,0,1,315.81,119Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref145), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M316.75,113.39l3.14-2a1.07,1.07,0,0,1,.44-.16l3.62-.49a1.11,1.11,0,0,1,.71.13l4.21,2.41a1.05,1.05,0,0,1,.48.54l.49,1.16a1.13,1.13,0,0,1-1.15,1.56h0a1.17,1.17,0,0,1-.81-.47l-.3-.43a1.14,1.14,0,0,0-1.4-.37L323,116.84a1.18,1.18,0,0,1-.74.08l-5.2-1.24a1.12,1.12,0,0,1-.84-1.35l.05-.24A1.13,1.13,0,0,1,316.75,113.39Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref146), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M333.27,115.63l2.46.1a1.55,1.55,0,0,1,1.18.61l1.11,1.45a1.57,1.57,0,0,1-.32,2.22l-.05,0a1.57,1.57,0,0,1-1.41.22l-2.6-.86a1.42,1.42,0,0,1-.47-.25l-.93-.72a1.61,1.61,0,0,1-.6-1.26h0A1.57,1.57,0,0,1,333.27,115.63Z",
    style: {
      fill: "#c58fff"
    }
  }), _ref147), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 323.8,
    y: 123.73,
    width: 5.35,
    height: 1.08,
    transform: "translate(-18.97 176.21) rotate(-29.39)",
    style: {
      fill: "#a9ff03"
    }
  }), _ref148), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 316.59,
    y: 128.92,
    width: 5.17,
    height: 1.08,
    transform: "translate(-11.41 226.15) rotate(-38.38)",
    style: {
      fill: "#a9ff03"
    }
  }), _ref149), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 330.21,
    y: 120.58,
    width: 4.07,
    height: 1.08,
    transform: "translate(-2.7 7.69) rotate(-1.32)",
    style: {
      fill: "#a9ff03"
    }
  }), _ref150), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 325.35,
    y: 116.42,
    width: 2.37,
    height: 1.08,
    transform: "translate(-17.72 159.27) rotate(-26.71)",
    style: {
      fill: "#a9ff03"
    }
  }), _ref151), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M314.4,140.1a9.87,9.87,0,0,0-2.68-5l-.09-.09.74-.78.09.09a10.82,10.82,0,0,1,3,5.58l0,.13-1.06.18Z",
    style: {
      fill: "#a9ff03"
    }
  }), _ref152), _ref153, _ref154, _ref155, _ref156), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 291.74,
    y: 120.67,
    width: 1.08,
    height: 3.35,
    transform: "translate(65.35 343.48) rotate(-66.97)",
    style: {
      fill: "#a9ff03"
    }
  }), _ref157)), _ref158, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "162.45 135.57 166.22 132.89 192.85 171.8 188.71 174.63 162.45 135.57",
    style: {
      fill: "#c58fff"
    }
  }), _ref159), /*#__PURE__*/React.createElement("polygon", {
    points: "54.87 210.68 0 248.06 80.16 248.06 54.87 210.68",
    style: {
      fill: "#a9ff03"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "136.03 209.93 110.77 172.49 120.12 166.11 145.32 203.6 136.03 209.93",
    style: {
      fill: "#a9ff03"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.83 248.06 48.51 215 57.86 208.62 83.06 246.11 80.2 248.06 70.83 248.06",
    style: {
      fill: "#a9ff03"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopypageImage);
export default __webpack_public_path__ + "static/media/copypage-image.70a4c644.svg";
export { ForwardRef as ReactComponent };